/* eslint-disable camelcase */
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uuid from 'uuid/v4';
import _ from 'lodash';
import styled from 'styled-components';
import { leastIndex } from 'd3-array';
import CrosstabEditor from './CrosstabEditor';
import * as crosstabActions from '../actions/crosstabActions';
import * as studyActions from '../actions/studyActions';
import * as datahaulActions from '../actions/datahaulActions';
import * as dictionaryActions from '../actions/dictionaryActions';
import * as preferenceActions from '../actions/preferencesActions';
import * as quickReportsActions from '../actions/quickReportsActions';
import * as cacActions from '../actions/cacActions';
import Modal from '../components/common/Modal/Modal';
import GenericButton from '../components/common/GenericButton';
import ValidateStudyModal from '../components/common/ValidateStudyModal';
import ValidateMultipleStudyModal from '../components/common/ValidateMultipleStudyModal';
import UserStateModal from '../components/common/UserStateModal';
import ToolPalette from '../components/crosstab/ToolPalette';
import {
  getDefaultCells,
  DEFAULT_CROSSTAB_DATA_KEYS,
  createDataSmartSearch,
  trendValidityCheck,
  trendInvalidList,
} from '../util/CrosstabUtils';
import {
  divideJointExpressions,
  buildSPC2Object,
  getSampleWeightedParamsForAutocodeNodes,
} from '../util/autocodeUtils';
import { setModuleDataOnSave } from '../util/preferenceUtils';
import {
  saveTrackingData,
  storeUnsavedData,
  openLastCrosstab,
  discardLastCrosstab,
  getLastUnsavedDetails,
  saveLastCrosstab,
} from '../util/trackerUtils';
import {
  TOOL_SHARE_BUTTON,
  TOOL_SAVE_CROSSTAB,
  PAGE_VISIT_DATAHAUL,
  PAGE_VISIT_CROSSTAB,
  DATAHAUL_RUN_REPORT,
  SAVE_LAST_CROSSTAB_BTN_CLICK,
  OPEN_LAST_CROSSTAB_BTN_CLICK,
  DISCARD_LAST_CROSSTAB_BTN_CLICK,
  CLOSE_MODAL_BTN_CLICK,
  DATAHAUL_CONSTANT,
  CROSSTAB_CONSTANT,
  PREFERENCE_STUDY,
  PREFERENCE_CROSSTAB,
  PREFERENCE_CHART_VIEW,
  PREFERENCE_STUDY_WEIGHTING,
  PREFERENCE_CROSSTAB_EDITOR,
  PREFERENCE_DATAHAUL,
  CROSSTAB_FEATUREID,
  DATAHAUL_FEATUREID,
  DV_DEFAULT_VALUE,
} from '../constants';

import { toastWarning } from '../util/toastUtils';
import {
  isFeaturePresent,
  getStudyFromStudies,
  getStudiesAsList,
  filterStudyList,
  exportFileTitle,
} from '../util/CommonUtils';
import WarningIcon from './WarningIcon';
import { SPC2, APP_ROOT_URL } from '../actions/urlTypes';
import {
  INSUFFICIENT_DATA_MODAL_TEXT,
  CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT,
  CAC_MAXIMUM_PROJECT_COUNT,
  CAC_MODULE_TITLE,
  CAC_MAX_LIMIT_REACHED_LABEL,
  CAC_LEFT_PANEL_VIEW_LABEL,
} from '../components/corrCluster/CacConstants';
import PortalModal from '../components/common/Modal/PortalModal';
import ValidateTrendModal from '../components/common/ValidateTrendModal';
import {
  AC_NODETYPE_DATAPOINT,
  AC_NODETYPE_FUNC,
} from '../components/autocode/AutocodeConstants';

const warnCTLimitStyle = {
  width: '50%',
  left: '30%',
  top: '12%',
};

const currClusterModalStyle = {
  width: '50%',
  left: '25%',
  top: '30%',
};

const validateModalStyle = {
  width: '50%',
  left: '30%',
  top: '12%',
};

const CrosstabSaveModalStyle = {
  width: '33%',
  height: 'auto',
  left: '36%',
  top: '15%',
};

const CrosstabSaveReplaceModalStyle = {
  width: '33%',
  height: 'auto',
  left: '36%',
  top: '15%',
};

const minRequireModalStyle = {
  width: '560px',
  left: 'calc(50vw - 280px)',
  width: '600px',
  left: 'calc(50vw - 300px)',
  top: '30%',
};
const updatedStudyPopupStyle = {
  width: '574px',
  height: '40px',
  left: '35%',
  top: '25%',
};

const H6 = styled.h6`
  font-size: 14px;
  font-weight: 700;
  padding-bottom: 10px;
`;

const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

class Crosstab extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isRunPressed: false,
      isButtonPressed: false,
      isValidated: false,
      invalidData: {},
      invalideRun: false,
      cellElementList: [...getDefaultCells(this.props.crosstabWeightTypes)],
      trendStudies: props.trendStudies || [],
      sideBarChecked: false,
      cbCrosstabRunType:
        props.userPreferences[PREFERENCE_CROSSTAB] &&
        props.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_CHART_VIEW]
          ? props.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_CHART_VIEW]
          : 'Private Eye View',
      dataScreen: '',
      ctbTitle: '',
      isCrosstabExist: false,
      editFromToolPalette: false,
      saveModalOpen: false,
      highlightAndFilter: undefined,
      conditionalFormatting: 'DefaultFilter',
      userStateData: '',
      showUserStateModal: false,
      openCrossTabMultipleProducts: false,
      defaultChartTypeValue:
        props.userPreferences[PREFERENCE_CROSSTAB] &&
        props.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_CHART_VIEW]
          ? props.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_CHART_VIEW]
          : 'Private Eye View',
      defaultScreenSelected:
        props.userPreferences[PREFERENCE_CROSSTAB] &&
        props.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_CROSSTAB_EDITOR]
          ? props.userPreferences[PREFERENCE_CROSSTAB][
              PREFERENCE_CROSSTAB_EDITOR
            ]
          : 'Smart Search',
      hideWeightType: false,
      autoUpdateStudy: false,
      hasCrosstabFeature: false,
      hasDataHaulFeature: false,
      hasCrosstabStudies: true,
      hasDatahaulStudies: true,
      isDictionarySearchOpened: false,
      loginState: true,
      toolPaletteSavedName: '',
      shouldTrendPopupShow: false,
      newCrosstabLoaded: false,
      showCurrCLusterModal: false,
      showCacMaxLimitModal: false,
      showStudyUpdatePopup: false,
      screenSelected: '',
      completeResponse: false,
      // add the radio selected value as part of a state of this parent
    };
    this.leftToolPalette = React.createRef();
    this.validateTrend = { flag: false, modalData: [] };
  }

  UNSAFE_componentWillMount() {
    const {
      modulePermissions,
      hasCrosstabStudies,
      hasDatahaulStudies,
    } = this.props;
    let hasCrosstabFeature = false;
    let hasDataHaulFeature = false;

    if (modulePermissions.length > 0) {
      hasCrosstabFeature = isFeaturePresent(
        CROSSTAB_FEATUREID,
        modulePermissions
      );
      hasDataHaulFeature = isFeaturePresent(
        DATAHAUL_FEATUREID,
        modulePermissions
      );
    }

    if (hasCrosstabStudies === undefined) {
      this.setState({ hasCrosstabStudies: true });
    } else {
      this.setState({ hasCrosstabStudies });
    }

    if (hasDatahaulStudies === undefined) {
      this.setState({ hasDatahaulStudies: true });
    } else {
      this.setState({ hasDatahaulStudies });
    }

    this.setState({ hasCrosstabFeature, hasDataHaulFeature }, () => {
      if (
        this.props.crosstabTableList &&
        this.props.crosstabTableList.length > 0
      ) {
        this.setState({ defaultScreenSelected: 'Smart Search' });
      }
    });
  }

  componentDidMount() {
    if (window.location.search && window.location.search === '?composer=1') {
      this.setState({ screenSelected: 'autocode' })
    }
    if (this.props.loginResponse) {
      let mainModule = '';
      let action = '';
      switch (this.props.dataScreen) {
        case DATAHAUL_CONSTANT: {
          action = PAGE_VISIT_DATAHAUL;
          mainModule = DATAHAUL_CONSTANT;
          break;
        }
        default: {
          action = PAGE_VISIT_CROSSTAB;
          mainModule = 'Crosstab';
          break;
        }
      }
      this.props.preferenceActions.setLastLocation({
        mainMenu: 'Essentials',
        mainModule,
      });
      this.callSaveTrackerFn({ action });

      if (
        this.props.dataScreen === DATAHAUL_CONSTANT &&
        this.props.latestStudies &&
        this.props.userPreferences &&
        this.props.userPreferences._dh &&
        this.props.userPreferences._dh._aus &&
        Object.keys(this.props.latestStudies).length > 0 &&
        this.props.userPreferences._dh._ds !== -1 &&
        this.props.latestStudies._dh.productNo !==
          this.props.userPreferences._dh._ds
      ) {
        const selectedStudy = getStudyFromStudies(
          filterStudyList(this.props.studies, DATAHAUL_FEATUREID),
          this.props.latestStudies._dh.productNo
        );
        this.props.studyActions.updateModuleStudy(
          DATAHAUL_CONSTANT,
          selectedStudy
        );
        const userPreferences = _.cloneDeep(this.props.userPreferences);
        userPreferences._dh._ds = selectedStudy.pn;
        this.saveUserPreference(userPreferences, true);
        this.showNewStudyToastMessage(this.props.datahaulStudy, selectedStudy);
      }

      this.customDidMount();
    }
    window.addEventListener('beforeunload', this.handleLeavePage);

    if (this.props.trendStudies && this.props.trendStudies.length > 0) {
      this.setState({ trendStudies: this.props.trendStudies });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.userPreferences &&
      nextProps.crosstabStudy &&
      nextProps.studies &&
      nextProps.latestStudies &&
      nextProps.userPreferences &&
      nextProps.userPreferences._ct &&
      this.state.loginState &&
      this.state.hasCrosstabFeature
    ) {
      this.openLastSaveModal();
      this.setState({ loginState: false });
    }
    if (this.props.hasCrosstabStudies !== nextProps.hasCrosstabStudies) {
      this.setState({ hasCrosstabStudies: nextProps.hasCrosstabStudies });
    }

    if (this.props.hasDatahaulStudies !== nextProps.hasDatahaulStudies) {
      this.setState({ hasDatahaulStudies: nextProps.hasDatahaulStudies });
    }

    if (
      this.state.autoUpdateStudy &&
      !nextProps.dataScreen &&
      nextProps.latestStudies &&
      nextProps.userPreferences &&
      nextProps.userPreferences._ct &&
      nextProps.userPreferences._ct._aus &&
      this.props.latestStudies !== nextProps.latestStudies &&
      Object.keys(nextProps.latestStudies).length > 0 &&
      nextProps.userPreferences._ct._ds !== -1 &&
      nextProps.latestStudies._ct.productNo !==
        nextProps.userPreferences._ct._ds
    ) {
      const selectedStudy = getStudyFromStudies(
        filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
        nextProps.latestStudies._ct.productNo
      );
      this.props.studyActions.updateModuleStudy(
        CROSSTAB_CONSTANT,
        selectedStudy
      );
      this.showNewStudyToastMessage(nextProps.crosstabStudy, selectedStudy);
      const userPreferences = _.cloneDeep(nextProps.userPreferences);
      userPreferences._ct._ds = selectedStudy.pn;
      this.saveUserPreference(userPreferences, true);

      this.setState({ autoUpdateStudy: false });
    }
    if (
      nextProps.dataScreen === DATAHAUL_CONSTANT &&
      nextProps.latestStudies &&
      nextProps.userPreferences &&
      nextProps.userPreferences._dh &&
      nextProps.userPreferences._dh._aus &&
      this.props.latestStudies !== nextProps.latestStudies &&
      Object.keys(nextProps.latestStudies).length > 0 &&
      nextProps.userPreferences._dh._ds !== -1 &&
      nextProps.latestStudies._dh.productNo !==
        nextProps.userPreferences._dh._ds
    ) {
      const selectedStudy = getStudyFromStudies(
        filterStudyList(this.props.studies, DATAHAUL_FEATUREID),
        nextProps.latestStudies._dh.productNo
      );
      this.props.studyActions.updateModuleStudy(
        DATAHAUL_CONSTANT,
        selectedStudy
      );
      this.showNewStudyToastMessage(nextProps.datahaulStudy, selectedStudy);
      const userPreferences = _.cloneDeep(nextProps.userPreferences);
      userPreferences._dh._ds = selectedStudy.pn;
      this.saveUserPreference(userPreferences, true);
    }

    if (
      nextProps.userPreferences &&
      nextProps.crosstabStudy &&
      !this.props.dataScreen &&
      this.props.studies &&
      nextProps.userPreferences[PREFERENCE_CROSSTAB] &&
      (nextProps.crosstabStudy.pn !==
        nextProps.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_STUDY] ||
        nextProps.crosstabStudy.wt !==
          nextProps.userPreferences[PREFERENCE_CROSSTAB][
            PREFERENCE_STUDY_WEIGHTING
          ]) &&
      this.props.preferenceFlags.crosstab
    ) {
      let selectedStudy;
      const updatedWeightType =
        nextProps.userPreferences[PREFERENCE_CROSSTAB][
          PREFERENCE_STUDY_WEIGHTING
        ] === 'Population'
          ? 1
          : 2;
      if (
        nextProps.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_STUDY] !== -1
      ) {
        selectedStudy = getStudyFromStudies(
          filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
          nextProps.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_STUDY]
        );
      } else {
        selectedStudy = _.cloneDeep(this.props.studies[0].sl[0]);
      }
      const hideWeightType =
        this.props.weightTypeStudies &&
        this.props.weightTypeStudies.some(el => {
          return el.pn === selectedStudy.pn;
        });
      this.setState(() => ({ hideWeightType }));
      selectedStudy = {
        ...selectedStudy,
        wt: updatedWeightType,
      };
      if (selectedStudy !== undefined) {
        this.props.studyActions.updateModuleStudy(
          CROSSTAB_CONSTANT,
          selectedStudy
        );
        const updatedWeightTypeObj =
          typeof nextProps.userPreferences[PREFERENCE_CROSSTAB][
            PREFERENCE_STUDY_WEIGHTING
          ] === 'string' ||
          nextProps.userPreferences[PREFERENCE_CROSSTAB][
            PREFERENCE_STUDY_WEIGHTING
          ].wt === undefined
            ? selectedStudy.cw[0]
            : nextProps.userPreferences[PREFERENCE_CROSSTAB][
                PREFERENCE_STUDY_WEIGHTING
              ];
        this.props.studyActions.updateWeightType(
          CROSSTAB_CONSTANT,
          updatedWeightTypeObj
        );
      }

      this.props.preferenceActions.setPreferenceFlag(CROSSTAB_CONSTANT, false);
    }

    if (
      nextProps.userPreferences &&
      nextProps.datahaulStudy &&
      this.props.dataScreen === DATAHAUL_CONSTANT &&
      this.props.studies &&
      nextProps.userPreferences[PREFERENCE_DATAHAUL] &&
      (nextProps.datahaulStudy.pn !==
        nextProps.userPreferences[PREFERENCE_DATAHAUL][PREFERENCE_STUDY] ||
        nextProps.datahaulStudy.wt !==
          nextProps.userPreferences[PREFERENCE_DATAHAUL][
            PREFERENCE_STUDY_WEIGHTING
          ]) &&
      this.props.preferenceFlags[DATAHAUL_CONSTANT]
    ) {
      let selectedStudy;
      const updatedWeightType =
        nextProps.userPreferences[PREFERENCE_DATAHAUL][
          PREFERENCE_STUDY_WEIGHTING
        ] === 'Population'
          ? 1
          : 2;
      if (
        nextProps.userPreferences[PREFERENCE_DATAHAUL][PREFERENCE_STUDY] !== -1
      ) {
        selectedStudy = getStudyFromStudies(
          filterStudyList(this.props.studies, DATAHAUL_FEATUREID),
          nextProps.userPreferences[PREFERENCE_DATAHAUL][PREFERENCE_STUDY]
        );
      } else {
        selectedStudy = _.cloneDeep(this.props.studies[0].sl[0]);
      }
      const hideWeightType =
        this.props.weightTypeStudies &&
        this.props.weightTypeStudies.some(el => {
          return el.pn === selectedStudy.pn;
        });
      this.setState(() => ({ hideWeightType }));
      selectedStudy = {
        ...selectedStudy,
        wt: updatedWeightType,
      };
      if (selectedStudy !== undefined) {
        this.props.studyActions.updateModuleStudy(
          DATAHAUL_CONSTANT.toLowerCase(),
          selectedStudy
        );
        const updatedWeightTypeObj =
          typeof nextProps.userPreferences[PREFERENCE_DATAHAUL][
            PREFERENCE_STUDY_WEIGHTING
          ] === 'string' ||
          nextProps.userPreferences[PREFERENCE_DATAHAUL][
            PREFERENCE_STUDY_WEIGHTING
          ].wt === undefined
            ? selectedStudy.cw[0]
            : nextProps.userPreferences[PREFERENCE_DATAHAUL][
                PREFERENCE_STUDY_WEIGHTING
              ];
        this.props.studyActions.updateWeightType(
          DATAHAUL_CONSTANT,
          updatedWeightTypeObj
        );
      }
      this.props.preferenceActions.setPreferenceFlag(DATAHAUL_CONSTANT, false);
    }

    if (
      nextProps.userPreferences &&
      nextProps.userPreferences[PREFERENCE_CROSSTAB] &&
      nextProps.userPreferences[PREFERENCE_CROSSTAB][
        PREFERENCE_CROSSTAB_EDITOR
      ] &&
      nextProps.userPreferences[PREFERENCE_CROSSTAB][
        PREFERENCE_CROSSTAB_EDITOR
      ] !== this.state.defaultScreenSelected &&
      !nextProps.dataScreen
    ) {
      if (
        !this.props.crosstabTableList ||
        this.props.crosstabTableList.length <= 0
      ) {
        this.setState({
          defaultScreenSelected:
            nextProps.userPreferences[PREFERENCE_CROSSTAB][
              PREFERENCE_CROSSTAB_EDITOR
            ],
        });
      }
    }
    if (
      nextProps.userPreferences &&
      nextProps.userPreferences[PREFERENCE_CROSSTAB] &&
      nextProps.userPreferences[PREFERENCE_CROSSTAB][
        PREFERENCE_CROSSTAB_EDITOR
      ] &&
      nextProps.userPreferences[PREFERENCE_CROSSTAB][
        PREFERENCE_CROSSTAB_EDITOR
      ] !== this.state.defaultScreenSelected &&
      !nextProps.dataScreen
    ) {
      if (
        !this.props.crosstabTableList ||
        this.props.crosstabTableList.length <= 0
      ) {
        this.setState({
          defaultScreenSelected:
            nextProps.userPreferences[PREFERENCE_CROSSTAB][
              PREFERENCE_CROSSTAB_EDITOR
            ],
        });
      }
    }

    if (
      nextProps.isTitleUpdated &&
      nextProps.loadedCrosstabInfo.title !== this.state.ctbTitle
    ) {
      this.setState({ ctbTitle: nextProps.loadedCrosstabInfo.title }, () => {});
    }
    if (this.state.hasCrosstabFeature) {
      if (
        nextProps.crosstabStudy &&
        nextProps.lastCrosstabData &&
        (!nextProps.isUserStatePopupShown ||
          (nextProps.isUserStatePopupShown &&
            !nextProps.isUserStatePopupShown.crosstab))
      ) {
        if (this.userStateModal) {
          this.userStateModal.show();
        }
        this.setState({ autoUpdateStudy: false });
      } else {
        if (this.userStateModal) {
          this.userStateModal.hide();
        }
        if (nextProps.noLastSavedCrosstabFlag) {
          this.setState({ autoUpdateStudy: true });
        }
      }
    }

    if (
      nextProps.dataScreen &&
      nextProps.dataScreen !== this.state.dataScreen
    ) {
      this.setState({ dataScreen: nextProps.dataScreen });
    }
    if (this.props.trendStudies !== nextProps.trendStudies) {
      this.setState(
        { trendStudies: nextProps.trendStudies },
        nextProps.trendStudies.length > 0
          ? () => this.runCrosstabOrTrend()
          : () => {}
      );
    }

    if (
      nextProps.datahaulStudy &&
      this.props.dataScreen === DATAHAUL_CONSTANT &&
      this.props.datahaulStudy !== nextProps.datahaulStudy
    ) {
      if (
        (this.props.DataHaulBases && this.props.DataHaulBases.length > 0) ||
        (this.props.DataHaulColumns && this.props.DataHaulColumns.length > 0)
      ) {
        this.studyChangeValidate(this.props, nextProps);
      }
    }
    if (
      nextProps.crosstabStudy &&
      !this.props.dataScreen &&
      !_.isEqual(this.props.crosstabStudy, nextProps.crosstabStudy)
    ) {
      if (
        !this.props.crosstabStudy ||
        this.props.crosstabStudy.pn !== nextProps.crosstabStudy.pn
      ) {
        this.props.studyActions.getFootNotes(
          'crosstab',
          nextProps.crosstabStudy.pn
        );
      }
      // showStudyUpdatePopup: true
      this.setState({ invalideRun: false, invalidData: {} });
      this.props.crosstabActions.clearSampleWeighted('ScratchDataGrid');
      if (nextProps.savedCrosstabData) {
        const productNo = nextProps.savedCrosstabData.products[0];
        const item = getStudyFromStudies(
          filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
          productNo
        );
        this.savedCrosstabDataValidate(nextProps.savedCrosstabData, item);
      } else if (
        (this.props.crosstabBases && this.props.crosstabBases.length > 0) ||
        (this.props.crosstabColumns && this.props.crosstabColumns.length > 0) ||
        (this.props.crosstabRows && this.props.crosstabRows.length > 0) ||
        (this.props.DataHaulBases && this.props.DataHaulBases.length > 0) ||
        (this.props.DataHaulColumns && this.props.DataHaulColumns.length > 0)
      ) {
        this.studyChangeValidate(this.props, nextProps);
        if (this.props.trendStudies && this.props.trendStudies.length > 0) {
          this.props.studyActions.clearTrendStudies();
        }
      } else if (
        this.state.crosstabTableList !== nextProps.crosstabTableList &&
        nextProps.crosstabTableList !== undefined &&
        nextProps.crosstabTableList.length > 0
      ) {
        this.studyChangeValidate(this.props, nextProps);
      }
    } else if (this.props.crosstabStudy && nextProps.savedCrosstabData) {
      const productNo = nextProps.savedCrosstabData.products[0];
      const item = getStudyFromStudies(
        filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
        productNo
      );
      this.savedCrosstabDataValidate(nextProps.savedCrosstabData, item);
    }
    if (
      this.props.crosstabTableList !== nextProps.crosstabTableList &&
      nextProps.crosstabTableList !== undefined &&
      nextProps.crosstabTableList.length > 0
    ) {
      this.setState(() => ({
        highlightAndFilter: nextProps.crosstabTableList[0].highlightAndFilter,
        conditionalFormatting:
          nextProps.crosstabTableList[0].conditionalFormatting,
        cbCrosstabRunType: nextProps.crosstabTableList[0].viewerGridType,
      }));
    }
    if (
      nextProps.savedCrosstabData &&
      this.props.savedCrosstabData !== nextProps.savedCrosstabData
    ) {
      const productNo = nextProps.savedCrosstabData.products[0];
      const weightType = nextProps.savedCrosstabData.weightType;
      const divisor = nextProps.savedCrosstabData.divisor;
      const customWeights = nextProps.savedCrosstabData.cw
        ? nextProps.savedCrosstabData.cw
        : null;

      if (nextProps.savedCrosstabData.attributes) {
        this.setState(() => ({
          highlightAndFilter:
            nextProps.savedCrosstabData.attributes.highlightAndFilter,
          conditionalFormatting:
            nextProps.savedCrosstabData.attributes.conditionalFormatting,
          cbCrosstabRunType: nextProps.savedCrosstabData.attributes.chartType,
        }));
      }

      if (nextProps.savedCrosstabData.products.length > 1) {
        const productNos = nextProps.savedCrosstabData.products.slice(
          1,
          nextProps.savedCrosstabData.products.length
        );
        const trendStudies = productNos.reduce((acc, trendProductNo) => {
          const trendStudy = getStudyFromStudies(
            filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
            trendProductNo
          );
          if (trendStudy) {
            acc.push({
              pn: trendStudy.pn,
              sd: trendStudy.sd,
            });
          }
          return acc;
        }, []);

        this.props.studyActions.setTrendStudies(trendStudies);
      } else {
        this.props.studyActions.setTrendStudies([]);
      }

      if (
        productNo !== this.props.crosstabStudy.pn ||
        weightType !== this.props.crosstabStudy.wt ||
        customWeights !== this.props.crosstabStudy.cw
      ) {
        const item = getStudyFromStudies(
          filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
          productNo
        );
        const StudyItem = {
          ...item,
          wt: weightType,
          // cw: customWeights,
        };
        const selectedWeightTypeArr = _.filter(StudyItem.cw, a => {
          return a.wt === weightType;
        });
        let selectedWeightType;
        if (selectedWeightTypeArr.length === 1) {
          selectedWeightType = selectedWeightTypeArr[0];
        } else if (divisor === DV_DEFAULT_VALUE) {
          selectedWeightType = _.find(selectedWeightTypeArr, a => {
            return a.dv === undefined;
          });
        } else {
          selectedWeightType = _.find(selectedWeightTypeArr, a => {
            return a.dv === divisor;
          });
        }
        let dataScreen = this.props.dataScreen
          ? this.props.dataScreen
          : CROSSTAB_CONSTANT;
        if (
          this.props.dataScreen &&
          this.props.dataScreen.includes(DATAHAUL_CONSTANT)
        ) {
          dataScreen = this.props.dataScreen.toLowerCase();
        }
        this.props.studyActions.updateModuleStudy(
          dataScreen,
          StudyItem,
          selectedWeightType
        );
        const fetchStandardBasetParams = {
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: StudyItem.pn,
        };
        if (
          !this.props.loginResponse.data.universityUser &&
          !this.props.dataScreen
        ) {
          this.props.crosstabActions.fetchStandardBaseList(
            fetchStandardBasetParams
          );
        }
      } else {
        const productNo = nextProps.savedCrosstabData.products[0];
        const item = getStudyFromStudies(
          filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
          productNo
        );
        this.savedCrosstabDataValidate(nextProps.savedCrosstabData, item);
      }
    }
    if (
      nextProps.gridsValidationResponse &&
      this.props.gridsValidationResponse !== nextProps.gridsValidationResponse
    ) {
      this.handleGridValidationResponse(
        nextProps.gridsValidationResponse,
        nextProps.CrosstabBreadCrumbsList,
        nextProps.DictionaryDetails
      );
      this.setState({
        gridsValidationResponseOriginal: nextProps.gridsValidationResponse,
      });
    }
    if (
      nextProps.userPreferences &&
      nextProps.userPreferences !== this.props.userPreferences
    ) {
      const runType =
        nextProps.userPreferences[PREFERENCE_CROSSTAB] &&
        nextProps.userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_CHART_VIEW]
          ? nextProps.userPreferences[PREFERENCE_CROSSTAB][
              PREFERENCE_CHART_VIEW
            ]
          : 'Private Eye View';
      this.setState({ cbCrosstabRunType: runType });
    }
    if (
      nextProps.loadedCrosstabInfo &&
      !_.isEqual(nextProps.loadedCrosstabInfo, this.props.loadedCrosstabInfo) &&
      nextProps.loadedCrosstabInfo.chartType &&
      nextProps.loadedCrosstabInfo.chartType !== this.state.cbCrosstabRunType
    ) {
      this.setState({
        cbCrosstabRunType: nextProps.loadedCrosstabInfo.chartType,
        newCrosstabLoaded: true,
      });
    }

    if (nextProps.trendComplete && this.state.completeResponse) {
      this.validateTrend.flag = false;
      this.validateTrend.modalData = [];
      this.setState({ completeResponse: false }, () => {
        this.renderReport('Trend', undefined);
      });
    }
    if (
      this.props.crosstabStudy &&
      nextProps.savedNewSPCCrosstabData &&
      this.props.savedNewSPCCrosstabData !== nextProps.savedNewSPCCrosstabData
    ) {
      const productNo = nextProps.savedNewSPCCrosstabData.products[0];
      const item = getStudyFromStudies(
        filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
        productNo
      );
      this.savedNewSPCCrosstabDataValidate(
        nextProps.savedNewSPCCrosstabData,
        item
      );

      // ***************************************************** //
      // Need to recheck these conditions //

      const weightType = nextProps.savedNewSPCCrosstabData.weightType;
      const divisor = nextProps.savedNewSPCCrosstabData.divisor;
      const customWeights = nextProps.savedNewSPCCrosstabData.cw
        ? nextProps.savedNewSPCCrosstabData.cw
        : null;

      // Cell highlighting and filtering rules
      if (nextProps.savedNewSPCCrosstabData.highlightAndFilter) {
        this.setState(() => ({
          highlightAndFilter:
            nextProps.savedNewSPCCrosstabData.highlightAndFilter,
          conditionalFormatting:
            nextProps.savedNewSPCCrosstabData.conditionalFormatting,
          cbCrosstabRunType: nextProps.savedNewSPCCrosstabData.chartType,
        }));
      }

      if (nextProps.savedNewSPCCrosstabData.products.length > 1) {
        const productNos = nextProps.savedNewSPCCrosstabData.products.slice(
          1,
          nextProps.savedNewSPCCrosstabData.products.length
        );
        const trendStudies = productNos.reduce((acc, trendProductNo) => {
          const trendStudy = getStudyFromStudies(
            filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
            trendProductNo
          );
          if (trendStudy) {
            acc.push({
              pn: trendStudy.pn,
              sd: trendStudy.sd,
            });
          }
          return acc;
        }, []);

        this.props.studyActions.setTrendStudies(trendStudies);
      } else {
        this.props.studyActions.setTrendStudies([]);
      }

      if (
        productNo !== this.props.crosstabStudy.pn ||
        weightType !== this.props.crosstabStudy.wt ||
        customWeights !== this.props.crosstabStudy.cw
      ) {
        const item = getStudyFromStudies(
          filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
          productNo
        );
        const StudyItem = {
          ...item,
          wt: weightType,
          // cw: customWeights,
        };
        const selectedWeightTypeArr = _.filter(StudyItem.cw, a => {
          return a.wt === weightType;
        });
        let selectedWeightType;
        if (selectedWeightTypeArr.length === 1) {
          selectedWeightType = selectedWeightTypeArr[0];
        } else if (divisor === DV_DEFAULT_VALUE) {
          selectedWeightType = _.find(selectedWeightTypeArr, a => {
            return a.dv === undefined;
          });
        } else {
          selectedWeightType = _.find(selectedWeightTypeArr, a => {
            return a.dv === divisor;
          });
        }
        let dataScreen = this.props.dataScreen
          ? this.props.dataScreen
          : CROSSTAB_CONSTANT;
        if (
          this.props.dataScreen &&
          this.props.dataScreen.includes(DATAHAUL_CONSTANT)
        ) {
          dataScreen = this.props.dataScreen.toLowerCase();
        }
        this.props.studyActions.updateModuleStudy(
          dataScreen,
          StudyItem,
          selectedWeightType
        );
        const fetchStandardBasetParams = {
          token: this.props.loginResponse.data.token,
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: StudyItem.pn,
        };
        if (
          !this.props.loginResponse.data.universityUser &&
          !this.props.dataScreen
        ) {
          this.props.crosstabActions.fetchStandardBaseList(
            fetchStandardBasetParams
          );
        }
      }
      // ************************************//
    }

    if (
      nextProps.newSpcGridValidationResponse &&
      this.props.newSpcGridValidationResponse !==
        nextProps.newSpcGridValidationResponse
    ) {
      this.handleNewSpcGridValidationResponse(
        nextProps.newSpcGridValidationResponse,
        nextProps.DictionaryDetails
      );
      this.setState({
        gridsValidationResponseOriginal: nextProps.newSpcGridValidationResponse,
      });
    }
    if (window.location.search && window.location.search === '?composer=1') {
      this.setState({ screenSelected: 'autocode' })
    } else {
      this.setState({ screenSelected: '' })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  customDidMount = () => {
    const { crosstabTableList } = this.props;
    if (
      crosstabTableList &&
      crosstabTableList.length > 0 &&
      this.state.cbCrosstabRunType !== crosstabTableList[0].viewerGridType
    ) {
      this.setState({ cbCrosstabRunType: crosstabTableList[0].viewerGridType });
    }

    // When coming from Build New button in Data enablement
    // important - Do not remove
    const showDictionarySearch = sessionStorage.getItem('showDictionarySearch');
    if (showDictionarySearch === 'true') {
      this.crosstabEditor.setDictionarySearchView(false);
      sessionStorage.removeItem('showDictionarySearch');
    }
  };

  saveUserPreference = (preferences, moduleUpdateFlag) => {
    const clonedPreferences = _.clone(preferences);
    this.props.preferenceActions
      .saveUserPreferences(
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        preferences
      )
      .then(response => {
        if (response && moduleUpdateFlag) {
          this.props.setModuleDataOnSave(clonedPreferences);
        }
      });
  };

  getGridData = () => ({
    kpiInfo: this.props.kpiInfo,
    ScratchDataGrid: this.props.crosstabScratch,
    BasesDataGrid: this.props.crosstabBases,
    RowsDataGrid: this.props.crosstabRows,
    ColumnsDataGrid: this.props.crosstabColumns,
    RecycleElements: this.props.recycleElements,
    DataHaulBasesDataGrid: this.props.DataHaulBases || [],
    DataHaulColumnsDataGrid: this.props.DataHaulColumns || [],
  });

  /** weight need to be sent from study selector */
  handleStudyChange = (val, updatedWeightType) => {
    if (
      this.state.cbCrosstabRunType === 'Trend' &&
      this.state.isDictionarySearchOpened === true
    ) {
      this.setState({ shouldTrendPopupShow: true });
    }
    this.props.crosstabActions.addDDNHCSData([]);
    this.props.crosstabActions.clearSampleWeightedKPIs();
    this.props.quickReportsActions.clearSampleWeightedKPIs();
    const dataScreen = this.props.dataScreen
      ? this.props.dataScreen.toLowerCase()
      : CROSSTAB_CONSTANT;
    const updatedStudy = {
      ...val,
      // wt: 1,   // updating weight type to population by default.
    };
    this.props.studyActions.updateModuleStudy(
      dataScreen,
      updatedStudy,
      updatedWeightType
    );
    this.props.dictionaryActions.clearTreeLoadNodeList();
    const fetchStandardBasetParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: updatedStudy.pn,
    };
    if (!this.props.loginResponse.data.universityUser) {
      this.props.crosstabActions.fetchStandardBaseList(
        fetchStandardBasetParams
      );
    }
    if (this.props.crosstabStudy.pn !== updatedStudy.pn) {
      this.props.crosstabActions.exportBaseSelectionList([], [], false);
    }
  };

  handleWeightType = () => {
    let hideWeightType;
    if (this.props.dataScreen === 'DataHaul' && this.props.datahaulStudy) {
      hideWeightType = this.props.weightTypeStudies.some(el => {
        return el.pn === this.props.datahaulStudy.pn;
      });
      this.setState(() => ({ hideWeightType }));
    } else if (this.props.crosstabStudy) {
      hideWeightType = this.props.weightTypeStudies.some(el => {
        return el.pn === this.props.crosstabStudy.pn;
      });
      this.setState(() => ({ hideWeightType }));
    }
  };

  getSelectedEditor = () =>
    this.crosstabEditor ? this.crosstabEditor.getSelectedEditor() : true;

  getCrosstabOrTrendParams = (runType, standardBaseID) => {
    this.props.crosstabActions.addDDNHCSData([]);
    const colExpressionList = [];
    const colHeaderList = [];
    const colOriginalHeaderList = [];
    const rowExpressionList = [];
    const rowHeaderList = [];
    const rowOriginalHeaderList = [];
    const baseList = [];
    const baseIDList = [];
    const baseHeaderList = [];
    const baseOriginalHeaderList = [];
    const products = [this.props.crosstabStudy.pn];
    const studyDescriptions = [this.props.crosstabStudy.sd];
    const ddNHCSReportsList = [];

    if (this.state.trendStudies.length > 0) {
      this.state.trendStudies.map(study => {
        products.push(study.pn);
        studyDescriptions.push(study.sd);
        return null;
      });
    }

    if (
      this.props.crosstabColumns &&
      this.props.dataScreen !== DATAHAUL_CONSTANT
    ) {
      this.props.crosstabColumns.map(item => {
        if (this.isValidKeyword(item.keyword, 'columnsGrid')) {
          colExpressionList.push(item.keyword);
          colHeaderList.push(item.title);
          colOriginalHeaderList.push(item.originalTitle);
        }

        return null;
      });
    }

    if (
      this.props.DataHaulColumns &&
      this.props.dataScreen === DATAHAUL_CONSTANT
    ) {
      this.props.DataHaulColumns.map(item => {
        if (this.isValidKeyword(item.keyword, 'datahaulColumnsGrid')) {
          colExpressionList.push(item.keyword);
          colHeaderList.push(item.title);
          colOriginalHeaderList.push(item.originalTitle);
        }

        return null;
      });
    }

    if (
      this.props.crosstabRows &&
      this.props.dataScreen !== DATAHAUL_CONSTANT
    ) {
      this.props.crosstabRows.map(item => {
        if (this.isValidKeyword(item.keyword, 'rowsGrid')) {
          rowExpressionList.push(item.keyword);
          rowHeaderList.push(item.title);
          rowOriginalHeaderList.push(item.originalTitle);
        }

        return null;
      });
    }

    if (
      this.props.crosstabBases &&
      this.props.dataScreen !== DATAHAUL_CONSTANT
    ) {
      if (runType !== 'StandardBases') {
        if (runType === 'Trend') {
          if (standardBaseID) {
            this.props.StandardBasesDataGridData.map(item => {
              if (standardBaseID === item.keyword) {
                baseIDList.push(item.id);
                baseList.push(item.keyword);
                baseHeaderList.push(item.title);
                baseOriginalHeaderList.push(item.originalTitle);
              }
              return null;
            });
          } else {
            this.props.crosstabBases.map(item => {
              this.isValidKeyword(item.keyword, 'basesGrid');
              baseIDList.push(item.id);
              baseList.push(item.keyword);
              baseHeaderList.push(item.title);
              baseOriginalHeaderList.push(item.originalTitle);
              return null;
            });
          }
        } else {
          this.props.crosstabBases.map(item => {
            this.isValidKeyword(item.keyword, 'basesGrid');
            baseIDList.push(item.id);
            baseList.push(item.keyword);
            baseHeaderList.push(item.title);
            baseOriginalHeaderList.push(item.originalTitle);
            return null;
          });
        }
      } else {
        this.props.StandardBasesDataGridData.map(item => {
          if (standardBaseID === item.keyword) {
            baseIDList.push(item.id);
            baseList.push(item.keyword);
            baseHeaderList.push(item.title);
            baseOriginalHeaderList.push(item.originalTitle);
          }
          return null;
        });
      }
    }

    if (
      this.props.DataHaulBases &&
      this.props.dataScreen === DATAHAUL_CONSTANT
    ) {
      this.props.DataHaulBases.map(item => {
        this.isValidKeyword(item.keyword, 'datahaulBasesGrid');
        baseIDList.push(item.id);
        baseList.push(item.keyword);
        baseHeaderList.push(item.title);
        baseOriginalHeaderList.push(item.originalTitle);
        return null;
      });
    }
    const title = exportFileTitle('DataHaul');

    if (runType === DATAHAUL_CONSTANT) {
      return {
        token: this.props.loginResponse.data.token,
        accountId: this.props.activeAccountId,
        uid: this.props.loginResponse.data.uid,
        weightType: this.props.datahaulWeightTypes.wt,
        divisor: this.props.datahaulWeightTypes.dv,
        selectedWeight: this.props.datahaulWeightTypes,
        title,
        fileName: title,
        products: [this.props.datahaulStudy.pn],
        colExpressionList,
        colHeaderList,
        reportFormat: 'Excel',
        baseList,
        baseHeaderList,
        selectedWeightName: this.props.datahaulWeightTypes.wn,
      };
    }
    if (
      this.props.crosstabBases &&
      this.props.dataScreen !== DATAHAUL_CONSTANT &&
      runType !== 'StandardBases'
    ) {
      if (runType === 'Trend') {
        if (!standardBaseID) {
          if (baseList.length === 0) {
            this.props.crosstabActions.setSelectedBase(
              DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
              DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
              DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE
            );
          } else {
            this.props.crosstabActions.setSelectedBase(
              baseIDList[0],
              baseList[0],
              'user-defined'
            );
          }
        }
      } else if (baseList.length === 0) {
        this.props.crosstabActions.setSelectedBase(
          DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
          DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE,
          DEFAULT_CROSSTAB_DATA_KEYS.Study_UNIVERSE
        );
      } else {
        this.props.crosstabActions.setSelectedBase(
          baseIDList[0],
          baseList[0],
          'user-defined'
        );
      }
    }
    let selectedStandardBaseFlag = runType === 'StandardBases';

    if (runType === 'Trend') {
      selectedStandardBaseFlag = standardBaseID !== undefined;
    }

    return {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      weightType: this.props.crosstabWeightTypes.wt,
      divisor: this.props.crosstabWeightTypes.dv,
      studyInfo: this.props.crosstabStudy,
      crosstabTitle:
        this.getCrosstabTitle() && this.getCrosstabTitle !== 'untitled'
          ? this.getCrosstabTitle()
          : this.state.crosstabTitle,
      products,
      studyDescriptions,
      colExpressionList,
      colHeaderList,
      rowExpressionList,
      rowHeaderList,
      baseIDList,
      baseList,
      baseHeaderList,
      colOriginalHeaderList,
      rowOriginalHeaderList,
      baseOriginalHeaderList,
      runType: runType === 'Trend' ? 'Trend' : this.state.cbCrosstabRunType,
      highlightAndFilter: this.state.highlightAndFilter,
      conditionalFormatting: this.state.conditionalFormatting,
      selectedBaseNode: this.props.selectedBaseNode,
      selectedBaseGroup: this.props.selectedBaseGroup,
      selectedBaseID: this.props.selectedBase,
      userDefinedBaseList: this.props.crosstabBases,
      standardBaseList: this.props.StandardBasesDataGridData,
      crosstabColumns: this.props.crosstabColumns,
      crosstabRows: this.props.crosstabRows,
      selectedStandardBaseFlag, // runType === 'StandardBases',
      crosstabRequestData: this.props.crosstabRequestData,
      selectedWeight: this.props.crosstabWeightTypes,
    };
  };

  resetHighlightFilterState = () => {
    const { userPreferences } = this.props;
    this.setState(() => ({
      cbCrosstabRunType:
        userPreferences[PREFERENCE_CROSSTAB] &&
        userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_CHART_VIEW]
          ? userPreferences[PREFERENCE_CROSSTAB][PREFERENCE_CHART_VIEW]
          : 'Private Eye View',
      highlightAndFilter: undefined,
      conditionalFormatting: 'DefaultFilter',
    }));
  };

  getCrosstabTitle = () => {
    if (this.crosstabEditor) {
      return this.crosstabEditor.getCrosstabTitle();
    }
    return null;
  };

  isValidKeyword = (keyword, gridType) => {
    let validFlag = true;
    if (
      this.state.invalidData &&
      this.state.invalidData[gridType] &&
      this.state.invalidData[gridType].selectedKeywords
    ) {
      this.state.invalidData[gridType].selectedKeywords.forEach(key => {
        if (keyword === key) validFlag = false;
      });
    }
    return validFlag;
  };

  handlecbCrossTabViewTypeChanged = cbCrosstabRunType => {
    if (cbCrosstabRunType === 'Trend') {
      this.setState({ cbCrosstabRunType }, () => {
        this.runCrosstabOrTrend();
      });
    } else {
      this.setState({ cbCrosstabRunType });
    }
  };

  validateInvalidData = () => {
    return new Promise(resolve => {
      const colHeaderList = this.props.crosstabColumns
        ? this.props.crosstabColumns.map(col => {
            return col.title;
          })
        : [];
      const rowHeaderList = this.props.crosstabRows
        ? this.props.crosstabRows.map(row => row.title)
        : [];

      const colExpressionList = this.props.crosstabColumns
        ? this.props.crosstabColumns.map(col => col.keyword)
        : [];
      const rowExpressionList = this.props.crosstabRows
        ? this.props.crosstabRows.map(row => row.keyword)
        : [];

      const baseExpressionList = this.props.crosstabBases
        ? this.props.crosstabBases.map(col => col.keyword)
        : [];
      const baseHeaderList = this.props.crosstabBases
        ? this.props.crosstabBases.map(row => row.title)
        : [];

      const isColLabelUpdated = this.props.crosstabColumns
        ? this.props.crosstabColumns.map(col => col.isLabelUpdated)
        : [];

      const isRowLabelUpdated = this.props.crosstabRows
        ? this.props.crosstabRows.map(row => row.isLabelUpdated)
        : [];

      let productNo = this.props.crosstabStudy.pn;
      let weightType = this.props.crosstabWeightTypes.wt;
      let divisor = this.props.crosstabWeightTypes.dv;

      if (this.props.dataScreen === DATAHAUL_CONSTANT) {
        productNo = this.props.datahaulStudy.pn;
        weightType = this.props.datahaulWeightTypes.wt;
        divisor = this.props.datahaulWeightTypes.dv;
      }
      const validateParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo,
        weightType,
        divisor,
        baseList: baseExpressionList,
        baseHeaderList,
        baseOriginalHeaderList: baseHeaderList,
        colExpressionList,
        colHeaderList,
        colOriginalHeaderList: colHeaderList,
        rowExpressionList,
        rowHeaderList,
        rowOriginalHeaderList: rowHeaderList,
        isColLabelUpdated,
        isRowLabelUpdated,
      };
      this.props.crosstabActions.validateCRB(validateParams).then(() => {
        resolve();
      });
    });
  };

  validateTrendResponse = () => {
    return new Promise(resolve => {
      const colHeaderList = this.props.crosstabColumns
        ? this.props.crosstabColumns.map(col => {
            return col.title;
          })
        : [];
      const rowHeaderList = this.props.crosstabRows
        ? this.props.crosstabRows.map(row => row.title)
        : [];

      const colExpressionList = this.props.crosstabColumns
        ? this.props.crosstabColumns.map(col => col.keyword)
        : [];
      const rowExpressionList = this.props.crosstabRows
        ? this.props.crosstabRows.map(row => row.keyword)
        : [];

      const baseExpressionList = this.props.crosstabBases
        ? this.props.crosstabBases.map(col => col.keyword)
        : [];
      const baseHeaderList = this.props.crosstabBases
        ? this.props.crosstabBases.map(row => row.title)
        : [];

      let productNumbers = this.state.trendStudies.map(res => res.pn);
      productNumbers = [...productNumbers, this.props.crosstabStudy.pn];
      const weightType = this.props.crosstabWeightTypes.wt;
      const divisor = this.props.crosstabWeightTypes.dv;
      const validateParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNumbers,
        weightType,
        divisor,
        baseList: baseExpressionList,
        baseHeaderList,
        colExpressionList,
        colHeaderList,
        rowExpressionList,
        rowHeaderList,
      };

      this.props.crosstabActions
        .validateTrendData(validateParams)
        .then(response => {
          resolve(response);
        });
    });
  };

  runCrosstabOrTrend = (
    runType = this.state.cbCrosstabRunType,
    standardBaseID
  ) => {
    if (runType !== 'StandardBases') {
      this.setState({ cbCrosstabRunType: runType });
    }
    this.setState(
      prevState => ({
        ...prevState,
        isButtonPressed: true,
      }),

      () => {
        if (runType === 'StandardBases') {
          this.renderReport(runType, standardBaseID);
        } else if (
          runType === 'Trend' &&
          this.state.trendStudies.length > 0 &&
          this.state.screenSelected !== 'autocode' &&
          !this.state.isDictionarySearchOpened
        ) {
          this.validateTrendResponse().then(res => {
            const trendCheck = trendValidityCheck(res);
            if (trendCheck) {
              setTimeout(() => {
                this.validateTrend.flag = true;
                this.validateTrend.modalData = res;
                this.setState({ completeResponse: false });
              }, 0);
            } else {
              this.validateTrend.flag = false;
              this.validateTrend.modalData = [];
              this.renderReport(runType, standardBaseID);
            }
          });
        } else {
          this.validateInvalidData().then(() => {
            this.renderReport(runType, standardBaseID);
          });
        }
      }
    );
  };

  runAfterWeightChange = (
    runType = this.state.cbCrosstabRunType,
    standardBaseID
  ) => {
    if (
      (runType !== 'Trend' &&
        this.props.trendStudies &&
        this.props.trendStudies.length > 0) ||
      (runType === 'Trend' && this.state.isDictionarySearchOpened === true)
    ) {
      this.props.studyActions.clearTrendStudies();
    }
    this.setState(
      prevState => ({
        ...prevState,
        isButtonPressed: true,
      }),

      () => {
        if (runType === 'StandardBases') {
          this.renderReport(runType, standardBaseID);
        } else {
          this.validateInvalidData().then(() => {
            this.renderReport(runType, standardBaseID);
          });
        }
      }
    );
  };

  renderReport = (runType, standardBaseID) => {
    let viewerGridType;
    viewerGridType =
      this.props.crosstabTableList &&
      this.props.crosstabTableList.length > 0 &&
      this.props.crosstabTableList[0].viewerGridType === 'Trend'
        ? 'Trend'
        : runType;
    if (
      this.props.loadedCrosstabInfo &&
      this.props.loadedCrosstabInfo.chartType &&
      this.props.loadedCrosstabInfo.chartType !== 'Trend' &&
      this.state.newCrosstabLoaded === true
    ) {
      this.setState({ newCrosstabLoaded: false });
      viewerGridType = this.props.loadedCrosstabInfo.chartType;
    }

    const totalRows =
      this.props.crosstabRows && this.props.crosstabRows.length
        ? this.props.crosstabRows.length
        : 1;
    const totalColumns =
      this.props.crosstabColumns && this.props.crosstabColumns.length
        ? this.props.crosstabColumns.length
        : 1;
    const totalCells = totalColumns * totalRows;
    if (totalCells > 100000) {
      this.warnCTLimit.show();
    } else {
      const param = this.getCrosstabOrTrendParams(
        viewerGridType,
        standardBaseID
      );
      if (runType === 'Trend' || viewerGridType === 'Trend') {
        if (this.props.trendStudies && this.props.trendStudies.length === 0) {
          if (this.state.isDictionarySearchOpened) {
            this.setState({
              shouldTrendPopupShow: true,
              completeResponse: false,
            });
          } else {
            this.leftToolPalette.current.showTrendModal();
            this.setState({
              shouldTrendPopupShow: false,
              completeResponse: false,
            });
          }
        }
        this.setState({ isRunPressed: true, completeResponse: false }, () =>
          this.props.crosstabActions.runCrosstab(param)
        );
      } else {
        this.setState({ isRunPressed: true, completeResponse: false }, () =>
          this.props.crosstabActions.runCrosstab(param)
        );
      }

      this.props.dictionaryActions.setDataPointAlreadyAdded(false);
    }
  };

  handleLeavePage = () => {
    this.props.storeUnsavedData(
      this.props.currentState,
      this.props.loginResponse.data.uid,
      this.props.activeAccountId
    );
  };

  handleTrendComplete = modalData => {
    const data = trendInvalidList(modalData);
    this.props.crosstabActions.trendComplete(data);
    this.setState({ completeResponse: true });
  };

  handleTrendCancel = () => {
    this.setState(
      {
        shouldTrendPopupShow: true,
        trendStudies: [],
        completeResponse: false,
      },
      () => {
        this.changeViewType();
        this.runCrosstabOrTrend();
      }
    );
    this.validateTrend.flag = false;
    this.validateTrend.modalData = [];
  };

  validateInvalidDataHaulData = () => {
    const colHeaderList = this.props.DataHaulColumns
      ? this.props.DataHaulColumns.map(col => {
          return col.title;
        })
      : [];

    const colExpressionList = this.props.DataHaulColumns
      ? this.props.DataHaulColumns.map(col => col.keyword)
      : [];

    const baseExpressionList = this.props.DataHaulBases
      ? this.props.DataHaulBases.map(col => col.keyword)
      : [];
    const baseHeaderList = this.props.DataHaulBases
      ? this.props.DataHaulBases.map(row => row.title)
      : [];

    let productNo = this.props.crosstabStudy.pn;
    let weightType = this.props.crosstabWeightTypes.wt;
    let divisor = this.props.crosstabWeightTypes.dv;

    if (this.props.dataScreen === DATAHAUL_CONSTANT) {
      productNo = this.props.datahaulStudy.pn;
      weightType = this.props.datahaulWeightTypes.wt;
      divisor = this.props.datahaulWeightTypes.dv;
    }
    const validateParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo,
      weightType,
      divisor,
      baseList: baseExpressionList,
      baseHeaderList,
      baseOriginalHeaderList: baseHeaderList,
      colExpressionList,
      colHeaderList,
      colOriginalHeaderList: colHeaderList,
    };
    return this.props.crosstabActions.validateCRB(validateParams);
  };

  runDataHaul = () => {
    this.callSaveTrackerFn({ action: DATAHAUL_RUN_REPORT });
    // socketActions.sendName(this.getCrosstabOrTrendParams())
    this.validateInvalidDataHaulData().then(() => {
      const params = this.getCrosstabOrTrendParams(DATAHAUL_CONSTANT);
      this.props.datahaulActions.updateDatahaulReportsKafka(params);
    });
  };

  savedCrosstabDataValidate = (savedCrosstabDataProps, crosstabStudy) => {
    this.props.crosstabActions.removeCrosstabData('savedCrosstabData');
    const apiCallsArr = [];
    if (
      savedCrosstabDataProps.colExpressionList &&
      savedCrosstabDataProps.colExpressionList.length > 0
    ) {
      const colExps = divideJointExpressions(
        savedCrosstabDataProps.colExpressionList
      );
      apiCallsArr.push(
        this.props.crosstabActions.getBreadCrumbs({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: crosstabStudy.pn,
          expressionList: [
            // ...colExps,
            ...savedCrosstabDataProps.colExpressionList,
          ],
          gridType: 'ColumnsGrid',
        })
      );

      apiCallsArr.push(
        this.props.crosstabActions.getDictionaryDataDetails({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: crosstabStudy.pn,
          expressionList: colExps,
          gridType: 'ColumnsGrid',
        })
      );
    }

    if (
      savedCrosstabDataProps.rowExpressionList &&
      savedCrosstabDataProps.rowExpressionList.length > 0
    ) {
      const rowExp = divideJointExpressions(
        savedCrosstabDataProps.rowExpressionList
      );
      apiCallsArr.push(
        this.props.crosstabActions.getBreadCrumbs({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: crosstabStudy.pn,
          expressionList: [
            // ...rowExp,
            ...savedCrosstabDataProps.rowExpressionList,
          ],
          gridType: 'RowsGrid',
        })
      );

      apiCallsArr.push(
        this.props.crosstabActions.getDictionaryDataDetails({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: crosstabStudy.pn,
          expressionList: rowExp,
          gridType: 'RowsGrid',
        })
      );
    }

    if (
      savedCrosstabDataProps.baseList &&
      savedCrosstabDataProps.baseList.length > 0
    ) {
      const basesExp = divideJointExpressions(savedCrosstabDataProps.baseList);
      apiCallsArr.push(
        this.props.crosstabActions.getBreadCrumbs({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: crosstabStudy.pn,
          expressionList: [
            // ...basesExp,
            ...savedCrosstabDataProps.baseList,
          ],
          gridType: 'BasesGrid',
        })
      );

      apiCallsArr.push(
        this.props.crosstabActions.getDictionaryDataDetails({
          uid: this.props.loginResponse.data.uid,
          accountId: this.props.activeAccountId,
          productNo: crosstabStudy.pn,
          expressionList: basesExp,
          gridType: 'BasesGrid',
        })
      );
    }

    if (savedCrosstabDataProps.products.length > 1) {
      const validateParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: [...savedCrosstabDataProps.products],
        weightType: this.props.crosstabWeightTypes.wt,
        divisor: this.props.crosstabWeightTypes.dv,
        baseList: savedCrosstabDataProps.baseList,
        baseHeaderList: savedCrosstabDataProps.baseHeaderList,
        baseOriginalHeaderList: savedCrosstabDataProps.baseHeaderList,
        colExpressionList: savedCrosstabDataProps.colExpressionList,
        colHeaderList: savedCrosstabDataProps.colHeaderList,
        colOriginalHeaderList: savedCrosstabDataProps.colHeaderList,
        rowExpressionList: savedCrosstabDataProps.rowExpressionList,
        rowHeaderList: savedCrosstabDataProps.rowHeaderList,
        rowOriginalHeaderList: savedCrosstabDataProps.rowHeaderList,
        isColLabelUpdated: savedCrosstabDataProps.isColLabelUpdated,
        isRowLabelUpdated: savedCrosstabDataProps.isRowLabelUpdated,
      };
      Promise.all(apiCallsArr)
        .then(() =>
          this.props.crosstabActions.validateCRBForMultipleProducts(
            validateParams
          )
        )
        .catch(() =>
          this.props.crosstabActions.validateCRBForMultipleProducts(
            validateParams
          )
        );
      this.setState({ openCrossTabMultipleProducts: true });
    } else {
      const validateParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: crosstabStudy.pn,
        weightType: this.props.crosstabWeightTypes.wt,
        divisor: this.props.crosstabWeightTypes.dv,
        baseList: savedCrosstabDataProps.baseList,
        baseHeaderList: savedCrosstabDataProps.baseHeaderList,
        baseOriginalHeaderList: savedCrosstabDataProps.baseHeaderList,
        colExpressionList: savedCrosstabDataProps.colExpressionList,
        colHeaderList: savedCrosstabDataProps.colHeaderList,
        colOriginalHeaderList: savedCrosstabDataProps.colHeaderList,
        rowExpressionList: savedCrosstabDataProps.rowExpressionList,
        rowHeaderList: savedCrosstabDataProps.rowHeaderList,
        rowOriginalHeaderList: savedCrosstabDataProps.rowHeaderList,
        isColLabelUpdated: savedCrosstabDataProps.isColLabelUpdated,
        isRowLabelUpdated: savedCrosstabDataProps.isRowLabelUpdated,
      };
      Promise.all(apiCallsArr)
        .then(() => this.props.crosstabActions.validateCRB(validateParams))
        .catch(() => this.props.crosstabActions.validateCRB(validateParams));

      this.setState({ openCrossTabMultipleProducts: false });
    }
  };

  savedNewSPCCrosstabDataValidate = (
    savedNewSPCCrosstabDataProps,
    crosstabStudy
  ) => {
    // console.log('savedNewSPCCrosstabDataProps:', savedNewSPCCrosstabDataProps);
    this.props.crosstabActions.removeCrosstabData('savedNewSPCCrosstabData');

    if (savedNewSPCCrosstabDataProps.products.length > 1) {
      const validateParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: [...savedNewSPCCrosstabDataProps.products],
        weightType: this.props.crosstabWeightTypes.wt,
        divisor: this.props.crosstabWeightTypes.dv,
        baseList: savedNewSPCCrosstabDataProps.bases.map(item => item.keyword),
        baseHeaderList: savedNewSPCCrosstabDataProps.bases.map(
          item => item.title
        ),
        baseOriginalHeaderList: savedNewSPCCrosstabDataProps.bases.map(
          item => item.title
        ),
        colExpressionList: savedNewSPCCrosstabDataProps.columns.map(
          item => item.keyword
        ),
        colHeaderList: savedNewSPCCrosstabDataProps.columns.map(
          item => item.title
        ),
        colOriginalHeaderList: savedNewSPCCrosstabDataProps.columns.map(
          item => item.title
        ),
        rowExpressionList: savedNewSPCCrosstabDataProps.rows.map(
          item => item.keyword
        ),
        rowHeaderList: savedNewSPCCrosstabDataProps.rows.map(
          item => item.title
        ),
        rowOriginalHeaderList: savedNewSPCCrosstabDataProps.rows.map(
          item => item.title
        ),
        isColLabelUpdated: savedNewSPCCrosstabDataProps.isColLabelUpdated,
        isRowLabelUpdated: savedNewSPCCrosstabDataProps.isRowLabelUpdated,
        newSpcParams: _.cloneDeep(savedNewSPCCrosstabDataProps),
      };
      // console.log('validateParams:', validateParams);
      this.props.crosstabActions.validateNewSpcCRBForMultipleProducts(
        validateParams
      );
      // this.setState({ openCrossTabMultipleProducts: true });
    } else {
      const validateParams = {
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        productNo: crosstabStudy.pn,
        weightType: this.props.crosstabWeightTypes.wt,
        divisor: this.props.crosstabWeightTypes.dv,
        baseList: savedNewSPCCrosstabDataProps.bases.map(item => item.keyword),
        baseHeaderList: savedNewSPCCrosstabDataProps.bases.map(
          item => item.title
        ),
        baseOriginalHeaderList: savedNewSPCCrosstabDataProps.bases.map(
          item => item.title
        ),
        colExpressionList: savedNewSPCCrosstabDataProps.columns.map(
          item => item.keyword
        ),
        colHeaderList: savedNewSPCCrosstabDataProps.columns.map(
          item => item.title
        ),
        colOriginalHeaderList: savedNewSPCCrosstabDataProps.columns.map(
          item => item.title
        ),
        rowExpressionList: savedNewSPCCrosstabDataProps.rows.map(
          item => item.keyword
        ),
        rowHeaderList: savedNewSPCCrosstabDataProps.rows.map(
          item => item.title
        ),
        rowOriginalHeaderList: savedNewSPCCrosstabDataProps.rows.map(
          item => item.title
        ),
        isColLabelUpdated: savedNewSPCCrosstabDataProps.isColLabelUpdated,
        isRowLabelUpdated: savedNewSPCCrosstabDataProps.isRowLabelUpdated,
        newSpcParams: _.cloneDeep(savedNewSPCCrosstabDataProps),
      };
      // console.log('validateParams:', validateParams);
      this.props.crosstabActions.validateNewSpcCRB(validateParams);
      // this.setState({ openCrossTabMultipleProducts: false });
    }
  };

  studyChangeValidate = (props, nextProps) => {
    const baseList = [];
    const baseHeaderList = [];
    const baseOriginalHeaderList = [];
    const colExpressionList = [];
    const colHeaderList = [];
    const colOriginalHeaderList = [];
    const rowExpressionList = [];
    const rowHeaderList = [];
    const rowOriginalHeaderList = [];
    let productNo;
    let weightType;
    let divisor;
    let oldProductNo;
    if (!this.props.dataScreen) {
      productNo = nextProps.crosstabStudy.pn;
      oldProductNo = props.crosstabStudy && props.crosstabStudy.pn;
      weightType = nextProps.crosstabWeightTypes.wt;
      divisor = nextProps.crosstabWeightTypes.dv;
      if (props.crosstabBases) {
        props.crosstabBases.map(item => {
          baseList.push(item.keyword);
          baseHeaderList.push(item.title);
          baseOriginalHeaderList.push(item.originalTitle);
          return item;
        });
      }
      if (props.crosstabColumns) {
        props.crosstabColumns.map(item => {
          colExpressionList.push(item.keyword);
          colHeaderList.push(item.title);
          colOriginalHeaderList.push(item.originalTitle);
          return item;
        });
      }
      if (props.crosstabRows) {
        props.crosstabRows.map(item => {
          rowExpressionList.push(item.keyword);
          rowHeaderList.push(item.title);
          rowOriginalHeaderList.push(item.originalTitle);
          return item;
        });
      }
    } else if (this.props.dataScreen === DATAHAUL_CONSTANT) {
      productNo = nextProps.datahaulStudy.pn;
      weightType = nextProps.datahaulWeightTypes.wt;
      divisor = nextProps.datahaulWeightTypes.dv;
      if (props.DataHaulBases) {
        props.DataHaulBases.map(item => {
          baseList.push(item.keyword);
          baseHeaderList.push(item.title);
          baseOriginalHeaderList.push(item.originalTitle);
          return item;
        });
      }
      if (props.DataHaulColumns) {
        props.DataHaulColumns.map(item => {
          colExpressionList.push(item.keyword);
          colHeaderList.push(item.title);
          colOriginalHeaderList.push(item.originalTitle);
          return item;
        });
      }
    }
    const validateParams = {
      token: props.loginResponse.data.token,
      uid: props.loginResponse.data.uid,
      accountId: props.activeAccountId,
      productNo,
      oldProductNo,
      weightType,
      divisor,
      baseList,
      baseHeaderList,
      baseOriginalHeaderList,
      colExpressionList,
      colHeaderList,
      colOriginalHeaderList,
      rowExpressionList,
      rowHeaderList,
      rowOriginalHeaderList,
    };
    const apiCallsArr = [];
    if (!this.props.dataScreen) {
      if (colExpressionList && colExpressionList.length > 0) {
        apiCallsArr.push(
          this.props.crosstabActions.getBreadCrumbs({
            uid: this.props.loginResponse.data.uid,
            accountId: this.props.activeAccountId,
            productNo,
            expressionList: colExpressionList,
            gridType: 'ColumnsGrid',
          })
        );
        const colExp = divideJointExpressions(colExpressionList);
        apiCallsArr.push(
          this.props.crosstabActions.getDictionaryDataDetails({
            uid: this.props.loginResponse.data.uid,
            accountId: this.props.activeAccountId,
            productNo,
            expressionList: colExp,
            gridType: 'ColumnsGrid',
          })
        );
      }

      if (rowExpressionList && rowExpressionList.length > 0) {
        apiCallsArr.push(
          this.props.crosstabActions.getBreadCrumbs({
            uid: this.props.loginResponse.data.uid,
            accountId: this.props.activeAccountId,
            productNo,
            expressionList: rowExpressionList,
            gridType: 'RowsGrid',
          })
        );
        const rowExp = divideJointExpressions(rowExpressionList);
        apiCallsArr.push(
          this.props.crosstabActions.getDictionaryDataDetails({
            uid: this.props.loginResponse.data.uid,
            accountId: this.props.activeAccountId,
            productNo,
            expressionList: rowExp,
            gridType: 'RowsGrid',
          })
        );
      }
    }
    apiCallsArr.push(this.props.crosstabActions.validateCRB(validateParams));
    Promise.all(apiCallsArr);
  };

  handleGridValidationResponse = (
    gridsValidationResponse,
    CrosstabBreadCrumbsList,
    DictionaryDetails
  ) => {
    let smartSearchColumns = {};
    let smartSearchRows = {};
    let smartSearchBases = {};
    if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
      smartSearchColumns = this.props.crosstabColumns
        ? this.props.crosstabColumns.reduce(
            (acc, val) => ({
              ...acc,
              [val.keyword]: {
                dataSmartSearch: val.dataSmartSearch,
                isLabelUpdated: val.isLabelUpdated,
              },
            }),
            {}
          )
        : {};

      smartSearchRows = this.props.crosstabRows
        ? this.props.crosstabRows.reduce(
            (acc, val) => ({
              ...acc,
              [val.keyword]: {
                dataSmartSearch: val.dataSmartSearch,
                isLabelUpdated: val.isLabelUpdated,
              },
            }),
            {}
          )
        : {};

      smartSearchBases = this.props.crosstabBases
        ? this.props.crosstabBases.reduce(
            (acc, val) => ({
              ...acc,
              [val.keyword]: {
                dataSmartSearch: val.dataSmartSearch,
                isLabelUpdated: val.isLabelUpdated,
              },
            }),
            {}
          )
        : {};
    } else {
      smartSearchBases = this.props.DataHaulBases
        ? this.props.DataHaulBases.reduce(
            (acc, val) => ({
              ...acc,
              [val.keyword]: val.dataSmartSearch,
            }),
            {}
          )
        : {};

      smartSearchColumns = this.props.DataHaulColumns
        ? this.props.DataHaulColumns.reduce(
            (acc, val) => ({
              ...acc,
              [val.keyword]: val.dataSmartSearch,
            }),
            {}
          )
        : {};
    }

    this.props.crosstabActions.removeCrosstabData('gridsValidationResponse');
    const invalidData = {
      columnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      rowsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
      basesGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
      datahaulBasesGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
      datahaulColumnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
    };
    const validData = {
      columnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      rowsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      basesGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      datahaulBasesGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
      datahaulColumnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
      },
    };
    if (gridsValidationResponse.trendProducts !== undefined) {
      const allColList = [...gridsValidationResponse.trendProducts[0].colList];
      const allRowList = [...gridsValidationResponse.trendProducts[0].rowList];
      const allBaseList = [
        ...gridsValidationResponse.trendProducts[0].baseList,
      ];

      const invalidColLists = [];
      const invalidRowLists = [];
      const invalidBaseLists = [];

      // const isColListValid = false;

      gridsValidationResponse.trendProducts.map(obj => {
        if (obj.colList) {
          obj.colList.map(node => {
            if (!node.valid) {
              if (invalidColLists.indexOf(node.expression)) {
                invalidColLists.push(node.expression);
              }
            }
            return null;
          });
        }

        if (obj.rowList) {
          obj.rowList.map(node => {
            if (!node.valid) {
              if (invalidRowLists.indexOf(node.expression)) {
                invalidRowLists.push(node.expression);
              }
            }
            return null;
          });
        }

        if (obj.baseList) {
          obj.baseList.map(node => {
            if (!node.valid) {
              if (invalidBaseLists.indexOf(node.expression)) {
                invalidBaseLists.push(node.expression);
              }
            }
            return null;
          });
        }
        return obj;
      });

      allColList.map((node, index) => {
        if (invalidColLists.indexOf(node.expression) === -1) {
          validData.columnsGrid.selectedKeywords.push(node.expression);
          validData.columnsGrid.selectedNames.push(node.label);
          validData.columnsGrid.originalNames.push(
            gridsValidationResponse.colOriginalHeaderList[index]
          );

          if (
            Object.keys(smartSearchColumns).length > 0 &&
            smartSearchColumns[node.expression]
          ) {
            validData.columnsGrid.dataSmartSearch.push(
              smartSearchColumns[node.expression].dataSmartSearch
            );
          } else {
            validData.columnsGrid.dataSmartSearch.push(
              createDataSmartSearch(
                CrosstabBreadCrumbsList,
                DictionaryDetails,
                node.expression,
                node.label,
                'ColumnsGrid'
              )
            );
          }
          if (
            Object.keys(smartSearchColumns).length > 0 &&
            smartSearchColumns[node.expression]
          ) {
            validData.columnsGrid.isLabelUpdated.push(
              smartSearchColumns[node.expression].isLabelUpdated || false
            );
          } else if (Object.keys(smartSearchColumns).length === 0) {
            validData.columnsGrid.isLabelUpdated.push(
              gridsValidationResponse.isColLabelUpdated[index]
            );
          } else {
            validData.columnsGrid.isLabelUpdated.push(false);
          }
        } else {
          invalidData.columnsGrid.selectedKeywords.push(node.expression);
          invalidData.columnsGrid.selectedNames.push(node.label);
          invalidData.columnsGrid.originalNames.push(
            gridsValidationResponse.colOriginalHeaderList[index]
          );
          if (
            this.props.crosstabColumns &&
            this.props.crosstabColumns[index] &&
            this.props.crosstabColumns[index].keyword === node.expression
          ) {
            invalidData.columnsGrid.dataSmartSearch.push(
              this.props.crosstabColumns[index].dataSmartSearch
            );
          } else {
            invalidData.columnsGrid.dataSmartSearch.push(
              createDataSmartSearch(
                CrosstabBreadCrumbsList,
                DictionaryDetails,
                node.expression,
                node.label,
                'ColumnsGrid'
              )
            );
          }
        }
        return null;
      });

      allRowList.map((node, index) => {
        if (invalidRowLists.indexOf(node.expression) === -1) {
          validData.rowsGrid.selectedKeywords.push(node.expression);
          validData.rowsGrid.selectedNames.push(node.label);
          validData.rowsGrid.originalNames.push(
            gridsValidationResponse.rowOriginalHeaderList[index]
          );

          if (
            Object.keys(smartSearchRows).length > 0 &&
            smartSearchRows[node.expression]
          ) {
            validData.rowsGrid.dataSmartSearch.push(
              smartSearchRows[node.expression].dataSmartSearch
            );
          } else {
            validData.rowsGrid.dataSmartSearch.push(
              createDataSmartSearch(
                CrosstabBreadCrumbsList,
                DictionaryDetails,
                node.expression,
                node.label,
                'RowsGrid'
              )
            );
          }

          if (
            Object.keys(smartSearchRows).length > 0 &&
            smartSearchRows[node.expression]
          ) {
            validData.rowsGrid.isLabelUpdated.push(
              smartSearchRows[node.expression].isLabelUpdated || false
            );
          } else if (Object.keys(smartSearchRows).length === 0) {
            validData.rowsGrid.isLabelUpdated.push(
              gridsValidationResponse.isRowLabelUpdated[index]
            );
          } else {
            validData.rowsGrid.isLabelUpdated.push(false);
          }
        } else {
          invalidData.rowsGrid.selectedKeywords.push(node.expression);
          invalidData.rowsGrid.selectedNames.push(node.label);
          invalidData.rowsGrid.originalNames.push(
            gridsValidationResponse.rowOriginalHeaderList[index]
          );
          if (
            this.props.crosstabRows &&
            this.props.crosstabRows[index] &&
            this.props.crosstabRows[index].keyword === node.expression
          ) {
            invalidData.rowsGrid.dataSmartSearch.push(
              this.props.crosstabRows[index].dataSmartSearch
            );
          } else {
            invalidData.rowsGrid.dataSmartSearch.push(
              createDataSmartSearch(
                CrosstabBreadCrumbsList,
                DictionaryDetails,
                node.expression,
                node.label,
                'RowsGrid'
              )
            );
          }
        }
        return null;
      });

      allBaseList.map((node, index) => {
        if (invalidBaseLists.indexOf(node.expression) === -1) {
          validData.basesGrid.selectedKeywords.push(node.expression);
          validData.basesGrid.selectedNames.push(node.label);
          validData.basesGrid.originalNames.push(
            gridsValidationResponse.baseOriginalHeaderList[index]
          );
          // if (validData.basesGrid.dataSmartSearch) {
          //   validData.basesGrid.dataSmartSearch.push(
          //     smartSearchBases[node.expression]
          //   );
          // }

          if (
            Object.keys(smartSearchBases).length > 0 &&
            smartSearchBases[node.expression]
          ) {
            validData.basesGrid.dataSmartSearch.push(
              smartSearchBases[node.expression].dataSmartSearch
            );
          } else {
            validData.basesGrid.dataSmartSearch.push(
              createDataSmartSearch(
                CrosstabBreadCrumbsList,
                DictionaryDetails,
                node.expression,
                node.label,
                'BasesGrid'
              )
            );
          }

          if (
            Object.keys(smartSearchBases).length > 0 &&
            smartSearchBases[node.expression]
          ) {
            validData.basesGrid.isLabelUpdated.push(
              smartSearchBases[node.expression].isLabelUpdated || false
            );
          } else {
            validData.basesGrid.isLabelUpdated.push(false);
          }
        } else {
          invalidData.basesGrid.selectedKeywords.push(node.expression);
          invalidData.basesGrid.selectedNames.push(node.label);
          invalidData.basesGrid.originalNames.push(
            gridsValidationResponse.baseOriginalHeaderList[index]
          );
        }
        return null;
      });
    } else {
      gridsValidationResponse.colList.map((node, index) => {
        const colName = node.label;
        if (node.valid) {
          if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
            validData.columnsGrid.selectedKeywords.push(node.expression);
            validData.columnsGrid.selectedNames.push(colName);
            validData.columnsGrid.originalNames.push(
              gridsValidationResponse.colOriginalHeaderList[index]
            );

            if (
              Object.keys(smartSearchColumns).length > 0 &&
              smartSearchColumns[node.expression]
            ) {
              validData.columnsGrid.dataSmartSearch.push(
                smartSearchColumns[node.expression].dataSmartSearch
              );
            } else {
              validData.columnsGrid.dataSmartSearch.push(
                createDataSmartSearch(
                  CrosstabBreadCrumbsList,
                  DictionaryDetails,
                  node.expression,
                  node.label,
                  'ColumnsGrid'
                )
              );
            }

            if (
              Object.keys(smartSearchColumns).length > 0 &&
              smartSearchColumns[node.expression]
            ) {
              validData.columnsGrid.isLabelUpdated.push(
                smartSearchColumns[node.expression].isLabelUpdated || false
              );
            } else if (Object.keys(smartSearchColumns).length === 0) {
              validData.columnsGrid.isLabelUpdated.push(
                gridsValidationResponse.isColLabelUpdated[index]
              );
            } else {
              validData.columnsGrid.isLabelUpdated.push(false);
            }
          } else {
            validData.datahaulColumnsGrid.selectedKeywords.push(
              node.expression
            );
            validData.datahaulColumnsGrid.selectedNames.push(colName);
            validData.datahaulColumnsGrid.originalNames.push(
              gridsValidationResponse.colOriginalHeaderList[index]
            );
            if (validData.datahaulColumnsGrid.dataSmartSearch) {
              validData.datahaulColumnsGrid.dataSmartSearch.push(
                smartSearchColumns[node.expression]
              );
            }
          }
        } else if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
          invalidData.columnsGrid.selectedKeywords.push(node.expression);
          invalidData.columnsGrid.selectedNames.push(colName);
          invalidData.columnsGrid.originalNames.push(
            gridsValidationResponse.colOriginalHeaderList[index]
          );
          if (
            this.props.crosstabColumns &&
            this.props.crosstabColumns[index] &&
            this.props.crosstabColumns[index].keyword === node.expression
          ) {
            invalidData.columnsGrid.dataSmartSearch.push(
              this.props.crosstabColumns[index].dataSmartSearch
            );
          } else {
            invalidData.columnsGrid.dataSmartSearch.push(
              createDataSmartSearch(
                CrosstabBreadCrumbsList,
                DictionaryDetails,
                node.expression,
                node.label,
                'ColumnsGrid'
              )
            );
          }
        } else {
          invalidData.datahaulColumnsGrid.selectedKeywords.push(
            node.expression
          );
          invalidData.datahaulColumnsGrid.selectedNames.push(colName);
          invalidData.datahaulColumnsGrid.originalNames.push(
            gridsValidationResponse.colOriginalHeaderList[index]
          );
        }
        return null;
      });

      gridsValidationResponse.rowList.map((node, index) => {
        const rowName = node.label;
        if (node.valid) {
          validData.rowsGrid.selectedKeywords.push(node.expression);
          validData.rowsGrid.selectedNames.push(rowName);
          validData.rowsGrid.originalNames.push(
            gridsValidationResponse.rowOriginalHeaderList[index]
          );

          if (
            Object.keys(smartSearchRows).length > 0 &&
            smartSearchRows[node.expression]
          ) {
            validData.rowsGrid.dataSmartSearch.push(
              smartSearchRows[node.expression].dataSmartSearch
            );
          } else {
            validData.rowsGrid.dataSmartSearch.push(
              createDataSmartSearch(
                CrosstabBreadCrumbsList,
                DictionaryDetails,
                node.expression,
                node.label,
                'RowsGrid'
              )
            );
          }

          if (
            Object.keys(smartSearchRows).length > 0 &&
            smartSearchRows[node.expression]
          ) {
            validData.rowsGrid.isLabelUpdated.push(
              smartSearchRows[node.expression].isLabelUpdated || false
            );
          } else if (Object.keys(smartSearchRows).length === 0) {
            validData.rowsGrid.isLabelUpdated.push(
              gridsValidationResponse.isRowLabelUpdated[index]
            );
          } else {
            validData.rowsGrid.isLabelUpdated.push(false);
          }
        } else {
          invalidData.rowsGrid.selectedKeywords.push(node.expression);
          invalidData.rowsGrid.selectedNames.push(rowName);
          invalidData.rowsGrid.originalNames.push(
            gridsValidationResponse.rowOriginalHeaderList[index]
          );
          if (
            this.props.crosstabRows &&
            this.props.crosstabRows[index] &&
            this.props.crosstabRows[index].keyword === node.expression
          ) {
            invalidData.rowsGrid.dataSmartSearch.push(
              this.props.crosstabRows[index].dataSmartSearch
            );
          } else {
            invalidData.rowsGrid.dataSmartSearch.push(
              createDataSmartSearch(
                CrosstabBreadCrumbsList,
                DictionaryDetails,
                node.expression,
                node.label,
                'RowsGrid'
              )
            );
          }
        }
        return null;
      });

      gridsValidationResponse.baseList.map((node, index) => {
        const baseName = node.label;
        if (node.valid) {
          if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
            validData.basesGrid.selectedKeywords.push(node.expression);
            validData.basesGrid.selectedNames.push(baseName);
            validData.basesGrid.originalNames.push(
              gridsValidationResponse.baseOriginalHeaderList[index]
            );
            // if (validData.basesGrid.dataSmartSearch) {
            //   validData.basesGrid.dataSmartSearch.push(
            //     smartSearchBases[node.expression]
            //   );
            // }
            if (
              Object.keys(smartSearchBases).length > 0 &&
              smartSearchBases[node.expression]
            ) {
              validData.basesGrid.dataSmartSearch.push(
                smartSearchBases[node.expression].dataSmartSearch
              );
            } else {
              validData.basesGrid.dataSmartSearch.push(
                createDataSmartSearch(
                  CrosstabBreadCrumbsList,
                  DictionaryDetails,
                  node.expression,
                  node.label,
                  'BasesGrid'
                )
              );
            }

            if (
              Object.keys(smartSearchBases).length > 0 &&
              smartSearchBases[node.expression]
            ) {
              validData.basesGrid.isLabelUpdated.push(
                smartSearchBases[node.expression].isLabelUpdated || false
              );
            } else {
              validData.basesGrid.isLabelUpdated.push(false);
            }
          } else {
            validData.datahaulBasesGrid.selectedKeywords.push(node.expression);
            validData.datahaulBasesGrid.selectedNames.push(baseName);
            validData.datahaulBasesGrid.originalNames.push(
              gridsValidationResponse.baseOriginalHeaderList[index]
            );
            if (validData.datahaulBasesGrid.dataSmartSearch) {
              validData.datahaulBasesGrid.dataSmartSearch.push(
                smartSearchBases[node.expression]
              );
            }
          }
        } else if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
          invalidData.basesGrid.selectedKeywords.push(node.expression);
          invalidData.basesGrid.selectedNames.push(baseName);
          invalidData.basesGrid.originalNames.push(
            gridsValidationResponse.baseOriginalHeaderList[index]
          );
        } else {
          invalidData.datahaulBasesGrid.selectedKeywords.push(node.expression);
          invalidData.datahaulBasesGrid.selectedNames.push(baseName);
          invalidData.datahaulBasesGrid.originalNames.push(
            gridsValidationResponse.baseOriginalHeaderList[index]
          );
        }
        return null;
      });
    }
    if (
      invalidData.columnsGrid.selectedKeywords.length > 0 ||
      invalidData.rowsGrid.selectedKeywords.length > 0 ||
      invalidData.basesGrid.selectedKeywords.length > 0 ||
      invalidData.datahaulBasesGrid.selectedKeywords.length > 0 ||
      invalidData.datahaulColumnsGrid.selectedKeywords.length > 0
    ) {
      if (
        invalidData.columnsGrid.selectedKeywords.length > 0 &&
        gridsValidationResponse.colList
      ) {
        const validArr = gridsValidationResponse.colList.filter(
          item => item.valid === true
        );
        const response = gridsValidationResponse.colList;
        const newObj = {};
        validArr.forEach((item, index) => {
          const oldIndex = response.findIndex(res => res === item);
          if (oldIndex !== -1) {
            newObj[oldIndex] = index;
          }
        });
        this.props.crosstabActions.updateRenamedGridIndex(
          newObj,
          'ColumnsDataGrid'
        );
      }
      if (
        invalidData.rowsGrid.selectedKeywords.length > 0 &&
        gridsValidationResponse.rowList
      ) {
        const validArr = gridsValidationResponse.rowList.filter(
          item => item.valid === true
        );
        const response = gridsValidationResponse.rowList;
        const newObj = {};
        validArr.forEach((item, index) => {
          const oldIndex = response.findIndex(res => res === item);
          if (oldIndex !== -1) {
            newObj[oldIndex] = index;
          }
        });
        this.props.crosstabActions.updateRenamedGridIndex(
          newObj,
          'RowsDataGrid'
        );
      }
      this.setState({ invalidData });
      this.validateStudyModal.show();
    }
    let sampleWeightedParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.crosstabStudy.pn,
      divisor: this.props.crosstabStudy.dv,
      weightType: this.props.crosstabWeightTypes.wt,
    };

    if (validData.columnsGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ColumnsDataGrid',
        targetGrid: 'ColumnsDataGrid',
        expressionList: validData.columnsGrid.selectedKeywords,
        selectedNames: validData.columnsGrid.selectedNames,
        originalNames: validData.columnsGrid.originalNames,
        objSmartSearchArray: validData.columnsGrid.dataSmartSearch,
        oldProductNo: gridsValidationResponse.oldProductNo,
        isLabelUpdated: validData.columnsGrid.isLabelUpdated,
      };
      let kpiNotExistsFlag = false;
      const responseData = [];
      validData.columnsGrid.selectedKeywords.forEach(elems => {
        if (this.props.sampleWeightedKPIs[elems] === undefined) {
          kpiNotExistsFlag = true;
        } else {
          responseData.push(this.props.sampleWeightedKPIs[elems].data[0]);
        }
      });

      if (kpiNotExistsFlag) {
        this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      } else {
        sampleWeightedParams.response = responseData;
        this.props.crosstabActions.getSampleWeightedData(sampleWeightedParams);
      }
    } else if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('ColumnsDataGrid');
    }
    if (validData.rowsGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'RowsDataGrid',
        targetGrid: 'RowsDataGrid',
        expressionList: validData.rowsGrid.selectedKeywords,
        selectedNames: validData.rowsGrid.selectedNames,
        originalNames: validData.rowsGrid.originalNames,
        objSmartSearchArray: validData.rowsGrid.dataSmartSearch,
        oldProductNo: gridsValidationResponse.oldProductNo,
        isLabelUpdated: validData.rowsGrid.isLabelUpdated,
      };
      let kpiNotExistsFlag = false;
      const responseData = [];
      validData.rowsGrid.selectedKeywords.forEach(elems => {
        if (this.props.sampleWeightedKPIs[elems] === undefined) {
          kpiNotExistsFlag = true;
        } else {
          responseData.push(this.props.sampleWeightedKPIs[elems].data[0]);
        }
      });

      if (kpiNotExistsFlag) {
        this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      } else {
        sampleWeightedParams.response = responseData;
        this.props.crosstabActions.getSampleWeightedData(sampleWeightedParams);
      }
    } else if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('RowsDataGrid');
    }
    if (validData.basesGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'BasesDataGrid',
        targetGrid: 'BasesDataGrid',
        expressionList: validData.basesGrid.selectedKeywords,
        selectedNames: validData.basesGrid.selectedNames,
        originalNames: validData.basesGrid.originalNames,
        objSmartSearchArray: validData.basesGrid.dataSmartSearch,
        oldProductNo: gridsValidationResponse.oldProductNo,
      };
      let kpiNotExistsFlag = false;
      const responseData = [];
      validData.basesGrid.selectedKeywords.forEach(elems => {
        if (this.props.sampleWeightedKPIs[elems] === undefined) {
          kpiNotExistsFlag = true;
        } else {
          responseData.push(this.props.sampleWeightedKPIs[elems].data[0]);
        }
      });

      if (kpiNotExistsFlag) {
        this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      } else {
        sampleWeightedParams.response = responseData;
        this.props.crosstabActions.getSampleWeightedData(sampleWeightedParams);
      }
    } else if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('BasesDataGrid');
    }
    if (validData.datahaulBasesGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        productNo: this.props.datahaulStudy.pn,
        sourceGrid: 'DataHaulBasesDataGrid',
        targetGrid: 'DataHaulBasesDataGrid',
        expressionList: validData.datahaulBasesGrid.selectedKeywords,
        selectedNames: validData.datahaulBasesGrid.selectedNames,
        originalNames: validData.datahaulBasesGrid.originalNames,
        objSmartSearchArray: validData.datahaulBasesGrid.dataSmartSearch,
      };
      this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
    } else if (this.props.dataScreen === DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('DataHaulBasesDataGrid');
    }
    if (validData.datahaulColumnsGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        productNo: this.props.datahaulStudy.pn,
        sourceGrid: 'DataHaulColumnsDataGrid',
        targetGrid: 'DataHaulColumnsDataGrid',
        expressionList: validData.datahaulColumnsGrid.selectedKeywords,
        selectedNames: validData.datahaulColumnsGrid.selectedNames,
        originalNames: validData.datahaulColumnsGrid.originalNames,
        objSmartSearchArray: validData.datahaulColumnsGrid.dataSmartSearch,
      };
      this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
    } else if (this.props.dataScreen === DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('DataHaulColumnsDataGrid');
    }
  };

  handleNewSpcGridValidationResponse = (
    newSpcGridValidationResponse,
    DictionaryDetails
  ) => {
    // console.log('newSpcGridValidationResponse:', newSpcGridValidationResponse);
    // console.log('DictionaryDetails:', DictionaryDetails);

    this.props.crosstabActions.removeCrosstabData(
      'newSpcGridValidationResponse'
    );
    const invalidData = {
      columnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      rowsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      basesGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      datahaulBasesGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      datahaulColumnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
    };
    const validData = {
      columnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      rowsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      basesGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      datahaulBasesGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
      datahaulColumnsGrid: {
        selectedKeywords: [],
        selectedNames: [],
        originalNames: [],
        dataSmartSearch: [],
        isLabelUpdated: [],
      },
    };
    const invalidList = {
      rowsList: [],
      columnsList: [],
      basesList: [],
    };
    const validList = {
      rowsList: [],
      columnsList: [],
      basesList: [],
    };
    if (newSpcGridValidationResponse.trendProducts !== undefined) {
      const allColList = [
        ...newSpcGridValidationResponse.trendProducts[0].colList,
      ];
      const allRowList = [
        ...newSpcGridValidationResponse.trendProducts[0].rowList,
      ];
      const allBaseList = [
        ...newSpcGridValidationResponse.trendProducts[0].baseList,
      ];

      newSpcGridValidationResponse.trendProducts.map(obj => {
        if (obj.colList) {
          obj.colList.map(node => {
            if (!node.valid) {
              if (invalidList.columnsList.indexOf(node.expression)) {
                invalidList.columnsList.push(node.expression);
              }
            }
            return null;
          });
        }
        if (obj.rowList) {
          obj.rowList.map(node => {
            if (!node.valid) {
              if (invalidList.rowsList.indexOf(node.expression)) {
                invalidList.rowsList.push(node.expression);
              }
            }
            return null;
          });
        }
        if (obj.baseList) {
          obj.baseList.map(node => {
            if (!node.valid) {
              if (invalidList.basesList.indexOf(node.expression)) {
                invalidList.basesList.push(node.expression);
              }
            }
            return null;
          });
        }
        return obj;
      });

      allBaseList.forEach(element => {
        const expression = element.expression;
        const bases = newSpcGridValidationResponse.newSpcParams.bases.filter(
          item => item.keyword === expression
        )[0];
        if (invalidList.basesList.indexOf(expression) === -1) {
          validList.basesList.push(_.cloneDeep(bases.autocodenode));
        }
        // else {
        //   invalidList.basesList.push(_.cloneDeep(bases.autocodenode));
        // }
      });
      validData.basesGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Bases Valid',
        validList.basesList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );
      invalidData.basesGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Bases Invalid',
        invalidList.basesList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );

      allRowList.forEach(element => {
        const expression = element.expression;
        const rows = newSpcGridValidationResponse.newSpcParams.rows.filter(
          item => item.keyword === expression
        )[0];
        if (invalidList.rowsList.indexOf(expression) === -1) {
          validList.rowsList.push(_.cloneDeep(rows.autocodenode));
        }
        // else {
        //   invalidList.rowsList.push(_.cloneDeep(rows.autocodenode));
        // }
      });
      validData.rowsGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Rows Valid',
        validList.rowsList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );
      invalidData.rowsGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Rows Invalid',
        invalidList.rowsList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );

      allColList.forEach(element => {
        const expression = element.expression;
        const columns = newSpcGridValidationResponse.newSpcParams.columns.filter(
          item => item.keyword === expression
        )[0];
        if (invalidList.columnsList.indexOf(expression) === -1) {
          validList.columnsList.push(_.cloneDeep(columns.autocodenode));
        }
        // else {
        //   invalidList.columnsList.push(_.cloneDeep(columns.autocodenode));
        // }
      });
      validData.columnsGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Columns Valid',
        validList.columnsList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );
      invalidData.columnsGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Columns Invalid',
        invalidList.columnsList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );
    } else {
      newSpcGridValidationResponse.baseList.forEach(element => {
        const expression = element.expression;
        const bases = newSpcGridValidationResponse.newSpcParams.bases.filter(
          item => item.keyword === expression
        )[0];

        if (
          _.isEmpty(bases.autocodenode.data) &&
          bases.autocodenode.type === AC_NODETYPE_DATAPOINT
        ) {
          bases.autocodenode.data.keyword = bases.keyword;
        } else if (
          bases.autocodenode.type === AC_NODETYPE_FUNC &&
          (bases.autocodenode.data.funcName === null ||
            bases.autocodenode.data.funcName === undefined)
        ) {
          bases.autocodenode.data.noFuncKeyword = bases.keyword;
        }

        if (element.valid) {
          validList.basesList.push(_.cloneDeep(bases.autocodenode));
        } else {
          invalidList.basesList.push(_.cloneDeep(bases.autocodenode));
        }
      });
      validData.basesGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Bases Valid',
        validList.basesList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );
      invalidData.basesGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Bases Invalid',
        invalidList.basesList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );

      newSpcGridValidationResponse.colList.forEach(element => {
        const expression = element.expression;
        const columns = newSpcGridValidationResponse.newSpcParams.columns.filter(
          item => item.keyword === expression
        )[0];

        if (
          _.isEmpty(columns.autocodenode.data) &&
          columns.autocodenode.type === AC_NODETYPE_DATAPOINT
        ) {
          columns.autocodenode.data.keyword = columns.keyword;
        } else if (
          columns.autocodenode.type === AC_NODETYPE_FUNC &&
          (columns.autocodenode.data.funcName === null ||
            columns.autocodenode.data.funcName === undefined)
        ) {
          columns.autocodenode.data.noFuncKeyword = columns.keyword;
        }

        if (element.valid) {
          validList.columnsList.push(_.cloneDeep(columns.autocodenode));
        } else {
          invalidList.columnsList.push(_.cloneDeep(columns.autocodenode));
        }
      });
      validData.columnsGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Columns Valid',
        validList.columnsList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );
      invalidData.columnsGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Columns Invalid',
        invalidList.columnsList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );

      newSpcGridValidationResponse.rowList.forEach(element => {
        const expression = element.expression;
        const rows = newSpcGridValidationResponse.newSpcParams.rows.filter(
          item => item.keyword === expression
        )[0];

        if (
          _.isEmpty(rows.autocodenode.data) &&
          rows.autocodenode.type === AC_NODETYPE_DATAPOINT
        ) {
          rows.autocodenode.data.keyword = rows.keyword;
        } else if (
          rows.autocodenode.type === AC_NODETYPE_FUNC &&
          (rows.autocodenode.data.funcName === null ||
            rows.autocodenode.data.funcName === undefined)
        ) {
          rows.autocodenode.data.noFuncKeyword = rows.keyword;
        }

        if (element.valid) {
          validList.rowsList.push(_.cloneDeep(rows.autocodenode));
        } else {
          invalidList.rowsList.push(_.cloneDeep(rows.autocodenode));
        }
      });
      validData.rowsGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Rows Valid',
        validList.rowsList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );
      invalidData.rowsGrid = getSampleWeightedParamsForAutocodeNodes(
        // 'Rows Invalid',
        invalidList.rowsList,
        newSpcGridValidationResponse.newSpcParams.partsToShow
      );
    }
    // console.log('validData:', validData);
    // console.log('invalidData:', invalidData);

    if (
      invalidData.columnsGrid.selectedKeywords.length > 0 ||
      invalidData.rowsGrid.selectedKeywords.length > 0 ||
      invalidData.basesGrid.selectedKeywords.length > 0 ||
      invalidData.datahaulBasesGrid.selectedKeywords.length > 0 ||
      invalidData.datahaulColumnsGrid.selectedKeywords.length > 0
    ) {
      if (
        invalidData.columnsGrid.selectedKeywords.length > 0 &&
        newSpcGridValidationResponse.colList
      ) {
        const validArr = newSpcGridValidationResponse.colList.filter(
          item => item.valid === true
        );
        const response = newSpcGridValidationResponse.colList;
        const newObj = {};
        validArr.forEach((item, index) => {
          const oldIndex = response.findIndex(res => res === item);
          if (oldIndex !== -1) {
            newObj[oldIndex] = index;
          }
        });
        this.props.crosstabActions.updateRenamedGridIndex(
          newObj,
          'ColumnsDataGrid'
        );
      }
      if (
        invalidData.rowsGrid.selectedKeywords.length > 0 &&
        newSpcGridValidationResponse.rowList
      ) {
        const validArr = newSpcGridValidationResponse.rowList.filter(
          item => item.valid === true
        );
        const response = newSpcGridValidationResponse.rowList;
        const newObj = {};
        validArr.forEach((item, index) => {
          const oldIndex = response.findIndex(res => res === item);
          if (oldIndex !== -1) {
            newObj[oldIndex] = index;
          }
        });
        this.props.crosstabActions.updateRenamedGridIndex(
          newObj,
          'RowsDataGrid'
        );
      }
      this.setState({ invalidData });
      this.validateStudyModal.show();
    }

    let sampleWeightedParams = {
      token: this.props.loginResponse.data.token,
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      productNo: this.props.crosstabStudy.pn,
      divisor: this.props.crosstabStudy.dv,
      weightType: this.props.crosstabWeightTypes.wt,
    };

    if (validData.columnsGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ColumnsDataGrid',
        targetGrid: 'ColumnsDataGrid',
        expressionList: validData.columnsGrid.selectedKeywords,
        selectedNames: validData.columnsGrid.selectedNames,
        originalNames: validData.columnsGrid.originalNames,
        objSmartSearchArray: validData.columnsGrid.dataSmartSearch,
        oldProductNo: newSpcGridValidationResponse.oldProductNo,
        isLabelUpdated: validData.columnsGrid.isLabelUpdated,
      };
      let kpiNotExistsFlag = false;
      const responseData = [];
      validData.columnsGrid.selectedKeywords.forEach(elems => {
        if (this.props.sampleWeightedKPIs[elems] === undefined) {
          kpiNotExistsFlag = true;
        } else {
          responseData.push(this.props.sampleWeightedKPIs[elems].data[0]);
        }
      });

      if (kpiNotExistsFlag) {
        this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      } else {
        sampleWeightedParams.response = responseData;
        this.props.crosstabActions.getSampleWeightedData(sampleWeightedParams);
      }
    } else if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('ColumnsDataGrid');
    }
    if (validData.rowsGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'RowsDataGrid',
        targetGrid: 'RowsDataGrid',
        expressionList: validData.rowsGrid.selectedKeywords,
        selectedNames: validData.rowsGrid.selectedNames,
        originalNames: validData.rowsGrid.originalNames,
        objSmartSearchArray: validData.rowsGrid.dataSmartSearch,
        oldProductNo: newSpcGridValidationResponse.oldProductNo,
        isLabelUpdated: validData.rowsGrid.isLabelUpdated,
      };
      let kpiNotExistsFlag = false;
      const responseData = [];
      validData.rowsGrid.selectedKeywords.forEach(elems => {
        if (this.props.sampleWeightedKPIs[elems] === undefined) {
          kpiNotExistsFlag = true;
        } else {
          responseData.push(this.props.sampleWeightedKPIs[elems].data[0]);
        }
      });

      if (kpiNotExistsFlag) {
        this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      } else {
        sampleWeightedParams.response = responseData;
        this.props.crosstabActions.getSampleWeightedData(sampleWeightedParams);
      }
    } else if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('RowsDataGrid');
    }
    if (validData.basesGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'BasesDataGrid',
        targetGrid: 'BasesDataGrid',
        expressionList: validData.basesGrid.selectedKeywords,
        selectedNames: validData.basesGrid.selectedNames,
        originalNames: validData.basesGrid.originalNames,
        objSmartSearchArray: validData.basesGrid.dataSmartSearch,
        oldProductNo: newSpcGridValidationResponse.oldProductNo,
      };
      let kpiNotExistsFlag = false;
      const responseData = [];
      validData.basesGrid.selectedKeywords.forEach(elems => {
        if (this.props.sampleWeightedKPIs[elems] === undefined) {
          kpiNotExistsFlag = true;
        } else {
          responseData.push(this.props.sampleWeightedKPIs[elems].data[0]);
        }
      });

      if (kpiNotExistsFlag) {
        this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
      } else {
        sampleWeightedParams.response = responseData;
        this.props.crosstabActions.getSampleWeightedData(sampleWeightedParams);
      }
    } else if (this.props.dataScreen !== DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('BasesDataGrid');
    }
    if (validData.datahaulBasesGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'DataHaulBasesDataGrid',
        targetGrid: 'DataHaulBasesDataGrid',
        expressionList: validData.datahaulBasesGrid.selectedKeywords,
        selectedNames: validData.datahaulBasesGrid.selectedNames,
        originalNames: validData.datahaulBasesGrid.originalNames,
        objSmartSearchArray: validData.datahaulBasesGrid.dataSmartSearch,
      };
      this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
    } else if (this.props.dataScreen === DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('DataHaulBasesDataGrid');
    }
    if (validData.datahaulColumnsGrid.selectedKeywords.length > 0) {
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'DataHaulColumnsDataGrid',
        targetGrid: 'DataHaulColumnsDataGrid',
        expressionList: validData.datahaulColumnsGrid.selectedKeywords,
        selectedNames: validData.datahaulColumnsGrid.selectedNames,
        originalNames: validData.datahaulColumnsGrid.originalNames,
        objSmartSearchArray: validData.datahaulColumnsGrid.dataSmartSearch,
      };
      this.props.crosstabActions.getSampleWeighted(sampleWeightedParams);
    } else if (this.props.dataScreen === DATAHAUL_CONSTANT) {
      this.props.crosstabActions.clearSampleWeighted('DataHaulColumnsDataGrid');
    }
  };

  toggleCrosstabView = isViewScreenSelected =>
    this.crosstabEditor.toggleCrosstabView(isViewScreenSelected);

  handleMetricsChange = cellElementList => this.setState({ cellElementList });

  handleCrosstabEdit = (idKey, dataSmartSearch, keyword) =>
    this.crosstabEditor.handleCrosstabEdit(idKey, dataSmartSearch, keyword);

  resetSmarchSearch = () => this.crosstabEditor.resetSmarchSearch();

  resetTitle = () =>
    this.setState(() => ({ ctbTitle: '', isCrosstabExist: false }));

  handleOnChangeTitle = e =>
    this.setState(() => ({ ctbTitle: e.target.value }));

  handleSaveCrosstab = () => {
    this.callSaveTrackerFn({ action: TOOL_SAVE_CROSSTAB });
    this.setState(
      () => ({
        ctbTitle: this.props.loadedCrosstabInfo.title,
      }),
      () => {
        if (
          !this.props.crosstabTableList ||
          this.props.crosstabTableList.length === 0
        ) {
          this.setState(() => ({ ctbTitle: '' }));
          this.crosstabSaveModal.show();
          this.setState(() => ({ saveModalOpen: true }));
        } else if (
          this.props.crosstabTableList &&
          this.props.crosstabTableList.length > 0 &&
          !this.state.ctbTitle
        ) {
          this.setState(() => ({ ctbTitle: '' }));
          this.crosstabSaveModal.show();
          this.setState(() => ({ saveModalOpen: true }));
        } else {
          this.saveCrosstab(false);
        }
      }
    );
  };

  handleScreenSelection = screen => {
    this.setState({ screenSelected: screen });
  };

  resetInfo = () => {
    this.setState(() => ({
      saveModalOpen: false,
      ctbTitle: '',
      isCrosstabExist: false,
    }));
  };

  callBackFn = isExist => {
    if (
      isExist &&
      (!this.props.crosstabTableList ||
        this.props.crosstabTableList.length === 0 ||
        ((!this.props.crosstabTableList ||
          this.props.crosstabTableList.length > 0) &&
          this.state.saveModalOpen))
    ) {
      this.setState(() => ({
        isCrosstabExist: isExist,
      }));
    } else if (
      isExist &&
      (!this.props.crosstabTableList ||
        this.props.crosstabTableList.length > 0) &&
      !this.state.saveModalOpen
    ) {
      this.crosstabSaveReplaceModal.show();
    } else if (isExist === false) {
      this.crosstabSaveModal.hide();
      this.setState(() => ({
        isCrosstabExist: isExist,
        saveModalOpen: isExist,
      }));
    }
  };

  saveCrosstabNewSpc = isReplace => {
    const highlightAndFilterRules =
      this.props.crosstabTableList &&
      this.props.crosstabTableList.length > 0 &&
      this.props.crosstabTableList[0].conditionalFormatting === 'HNF'
        ? this.props.crosstabTableList[0].highlightAndFilter
        : {
            sample: { highlight: [], filter: [] },
            weighted: { highlight: [], filter: [] },
            vertical: { highlight: [], filter: [] },
            horizontal: { highlight: [], filter: [] },
            index: { highlight: [], filter: [] },
          };

    const conditionalFormatting =
      this.props.crosstabTableList && this.props.crosstabTableList.length > 0
        ? this.props.crosstabTableList[0].conditionalFormatting
        : 'DefaultFilter';

    const products = [this.props.crosstabStudy.pn];
    this.props.trendStudies.map(trend => products.push(trend.pn));

    const spcObject = buildSPC2Object(
      this.props.crosstabWeightTypes.wt,
      `${this.state.ctbTitle}`,
      this.props.crosstabWeightTypes.dv,
      products,
      this.props.crosstabBases,
      this.props.crosstabRows,
      this.props.crosstabColumns,
      this.props.partsToShow,
      conditionalFormatting,
      highlightAndFilterRules
    );

    const viewerGridType =
      this.props.crosstabTableList && this.props.crosstabTableList.length > 0
        ? this.props.crosstabTableList[0].viewerGridType
        : 'Private Eye View';

    const crosstabId = isReplace
      ? this.props.crosstabTableList[0].id
      : undefined;

    spcObject.attributes.chartType = viewerGridType;

    const savedCrosstabParams = {
      idKey:
        this.props.crosstabTableList && this.props.crosstabTableList.length > 0
          ? this.props.activeCrosstabTable.idKey
          : uuid(),
      uid: this.props.loginResponse.data.uid,
      accountId: this.props.activeAccountId,
      title: `${this.state.ctbTitle}`,
      crosstabId,
      callbackSpinnerControl: this.callbackSpinnerControl,
      isReplace,
      spcObject,
    };

    this.props.crosstabActions.saveNewSPCCrosstab(
      savedCrosstabParams,
      this.callBackFn
    );
  };

  saveCrosstab = isReplace => {
    if (SPC2) {
      this.saveCrosstabNewSpc(isReplace);
    } else {
      const products = [this.props.crosstabStudy.pn];
      const colExpressionList = [];
      const colHeaderList = [];
      const rowExpressionList = [];
      const rowHeaderList = [];
      const baseList = [];
      const baseHeaderList = [];

      const updatedCrosstabRows = _.cloneDeep(this.props.crosstabRows);
      const updatedCrosstabColumns = _.cloneDeep(this.props.crosstabColumns);
      const updatedCrosstabBases = _.cloneDeep(this.props.crosstabBases);

      updatedCrosstabRows.forEach((item, index) => {
        _.unset(updatedCrosstabRows[index], 'dataSmartSearch');
      });
      updatedCrosstabColumns.forEach((item, index) => {
        _.unset(updatedCrosstabColumns[index], 'dataSmartSearch');
      });
      updatedCrosstabBases.forEach((item, index) => {
        _.unset(updatedCrosstabBases[index], 'dataSmartSearch');
      });

      this.props.trendStudies.map(trend => products.push(trend.pn));

      if (this.props.crosstabBases !== undefined) {
        this.props.crosstabBases.map(item => {
          baseList.push(item.keyword);
          baseHeaderList.push(item.title);
          return item;
        });
      }
      if (this.props.crosstabColumns !== undefined) {
        this.props.crosstabColumns.map(item => {
          colExpressionList.push(item.keyword);
          colHeaderList.push(item.title);
          return item;
        });
      }

      if (this.props.crosstabRows !== undefined) {
        this.props.crosstabRows.map(item => {
          rowExpressionList.push(item.keyword);
          rowHeaderList.push(item.title);
          return item;
        });
      }

      const crosstabId = isReplace
        ? this.props.crosstabTableList[0].id
        : undefined;

      const highlightAndFilter =
        this.props.crosstabTableList && this.props.crosstabTableList.length > 0
          ? this.props.crosstabTableList[0].highlightAndFilter
          : undefined;

      const viewerGridType =
        this.props.crosstabTableList && this.props.crosstabTableList.length > 0
          ? this.props.crosstabTableList[0].viewerGridType
          : 'Private Eye View';

      const conditionalFormatting =
        this.props.crosstabTableList && this.props.crosstabTableList.length > 0
          ? this.props.crosstabTableList[0].conditionalFormatting
          : 'DefaultFilter';

      const savedCrosstabParams = {
        idKey:
          this.props.crosstabTableList &&
          this.props.crosstabTableList.length > 0
            ? this.props.activeCrosstabTable.idKey
            : uuid(),
        token: this.props.loginResponse.data.token,
        uid: this.props.loginResponse.data.uid,
        accountId: this.props.activeAccountId,
        weightType: this.props.crosstabWeightTypes.wt,
        divisor: this.props.crosstabWeightTypes.dv,
        title: this.state.ctbTitle,
        products,
        colExpressionList,
        colHeaderList,
        baseList,
        baseHeaderList,
        rowExpressionList,
        rowHeaderList,
        crosstabId,
        callbackSpinnerControl: this.callbackSpinnerControl,
        isReplace,
        attributes: {
          chartType: viewerGridType,
          conditionalFormatting,
          highlightAndFilter,
          crosstabRows: updatedCrosstabRows,
          crosstabBases: updatedCrosstabBases,
          crosstabColumns: updatedCrosstabColumns,
        },
      };
      this.props.crosstabActions.saveCrosstab(
        savedCrosstabParams,
        this.callBackFn
      );
    }
  };

  callbackSpinnerControl = flagSpinner => {
    this.setState({ flagSpinner });
  };

  handlesideBarToggle = () =>
    this.setState(prevState => ({ sideBarChecked: !prevState.sideBarChecked }));

  handleDictionarySearchOpened = isDictionarySearchOpened =>
    this.setState(
      {
        sideBarChecked: isDictionarySearchOpened,
        isDictionarySearchOpened,
      },
      () => {
        this.props.dictionaryActions.clearTreeNodes();
      }
    );

  changeViewType = () => {
    if (this.state.shouldTrendPopupShow) {
      this.leftToolPalette.current.showTrendModal();
      this.setState({ shouldTrendPopupShow: false });
    }
  };

  shareCrosstabIcon = e => {
    if (e.target.checked) {
      this.callSaveTrackerFn({ action: TOOL_SHARE_BUTTON });
    }
  };

  openLastSaveModal = () => {
    let currentModule = '';
    if (this.props.dataScreen === DATAHAUL_CONSTANT) {
      currentModule = DATAHAUL_CONSTANT;
    } else {
      currentModule = CROSSTAB_CONSTANT;
    }
    if (this.props.loginResponse) {
      this.props.getLastUnsavedDetails(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        currentModule
      );
    }
  };

  autoUpdateOnDiscardLastCrosstab = () => {
    const selectedStudy = getStudyFromStudies(
      filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
      this.props.latestStudies._ct.productNo
    );
    this.props.studyActions.updateModuleStudy(CROSSTAB_CONSTANT, selectedStudy);
    this.showNewStudyToastMessage(this.props.crosstabStudy, selectedStudy);
    const userPreferences = _.cloneDeep(this.props.userPreferences);
    userPreferences._ct._ds = selectedStudy.pn;
    this.saveUserPreference(userPreferences, true);

    this.setState({ autoUpdateStudy: false });
  };

  autoUpdateOnOpenLastCrosstab = () => {
    const selectedStudy = getStudyFromStudies(
      filterStudyList(this.props.studies, CROSSTAB_FEATUREID),
      this.props.latestStudies._ct.productNo
    );
    const userPreferences = _.cloneDeep(this.props.userPreferences);
    userPreferences._ct._ds = selectedStudy.pn;
    this.saveUserPreference(userPreferences, false);
  };

  showNewStudyToastMessage = (beforeUpdateStudy, afterUpdateStudy) => {
    toastWarning(
      <span style={{ color: 'black', width: '400px' }}>
        Your default study has been updated from
        <span style={{ fontWeight: 'bold' }}> {beforeUpdateStudy.sd} </span>
        to <span style={{ fontWeight: 'bold' }}> {afterUpdateStudy.sd}. </span>
        This change is occuring because you have previously set your preferences
        to automatically update your study on start-up when a new version of the
        study type is released.
      </span>
    );
  };

  renderUserStateModal = () => (
    <Modal
      title="Open Last Crosstab"
      ref={node => {
        this.userStateModal = node;
        return this.userStateModal;
      }}
      dialogStyles={validateModalStyle}
      discardLastCrosstab={() =>
        this.props.discardLastCrosstab(CROSSTAB_CONSTANT)
      }
      closeTracker={() => {
        this.callSaveTrackerFn({ action: CLOSE_MODAL_BTN_CLICK });

        if (
          !this.props.dataScreen &&
          this.props.latestStudies &&
          Object.keys(this.props.latestStudies).length > 0 &&
          this.props.userPreferences &&
          this.props.userPreferences._ct &&
          this.props.userPreferences._ct._aus &&
          this.props.latestStudies._ct.productNo !==
            this.props.userPreferences._ct._ds
        ) {
          this.autoUpdateOnDiscardLastCrosstab();
        }
      }}
    >
      {this.props.dataScreen !== DATAHAUL_CONSTANT && (
        <div>
          <UserStateModal
            openLastCrosstab={() => {
              this.callSaveTrackerFn({ action: OPEN_LAST_CROSSTAB_BTN_CLICK });
              this.props.openLastCrosstab(CROSSTAB_CONSTANT);
              this.setState({ autoUpdateStudy: false });

              if (
                !this.props.dataScreen &&
                this.props.latestStudies &&
                Object.keys(this.props.latestStudies).length > 0 &&
                this.props.userPreferences &&
                this.props.userPreferences._ct &&
                this.props.userPreferences._ct._aus &&
                this.props.latestStudies._ct.productNo !==
                  this.props.userPreferences._ct._ds
              ) {
                this.autoUpdateOnOpenLastCrosstab();
              }
            }}
            discardLastCrosstab={() => {
              this.callSaveTrackerFn({
                action: DISCARD_LAST_CROSSTAB_BTN_CLICK,
              });
              this.props.discardLastCrosstab(
                CROSSTAB_CONSTANT,
                this.props.loginResponse.data.uid,
                this.props.activeAccountId
              );

              this.setState({ autoUpdateStudy: false });

              if (
                !this.props.dataScreen &&
                this.props.latestStudies &&
                Object.keys(this.props.latestStudies).length > 0 &&
                this.props.userPreferences &&
                this.props.userPreferences._ct &&
                this.props.userPreferences._ct._aus &&
                this.props.latestStudies._ct.productNo !==
                  this.props.userPreferences._ct._ds
              ) {
                this.autoUpdateOnDiscardLastCrosstab();
              }
            }}
            saveLastCrosstab={() => {
              this.callSaveTrackerFn({ action: SAVE_LAST_CROSSTAB_BTN_CLICK });
              this.props.saveLastCrosstab(
                CROSSTAB_CONSTANT,
                this.handleSaveCrosstab
              );
              this.setState({ autoUpdateStudy: false });

              if (
                !this.props.dataScreen &&
                this.props.latestStudies &&
                Object.keys(this.props.latestStudies).length > 0 &&
                this.props.userPreferences &&
                this.props.userPreferences._ct &&
                this.props.userPreferences._ct._aus &&
                this.props.latestStudies._ct.productNo !==
                  this.props.userPreferences._ct._ds
              ) {
                this.autoUpdateOnOpenLastCrosstab();
              }
            }}
            lastCrosstabData={this.props.lastCrosstabData}
          />
        </div>
      )}
    </Modal>
  );

  enableCorrespondence = () => {
    const {
      crosstabBases,
      crosstabColumns,
      crosstabRows,
      crosstabStudy,
      selectedBaseGroup,
      selectedBaseNode,
      StandardBasesDataGridData,
      activeCrosstabTable,
      cacProjectCount,
    } = this.props;
    if (cacProjectCount < CAC_MAXIMUM_PROJECT_COUNT) {
      if (
        activeCrosstabTable &&
        activeCrosstabTable.rowExpressionList &&
        activeCrosstabTable.rowExpressionList.length >=
          CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT &&
        activeCrosstabTable.colExpressionList &&
        activeCrosstabTable.colExpressionList.length >=
          CAC_COLUMN_ROW_CROSSTAB_MIN_COUNT
      ) {
        let selectedBase = [];
        if (
          selectedBaseGroup === 'user-defined' &&
          selectedBaseNode !== 'StudyUniverseKey'
        ) {
          selectedBase = crosstabBases
            .filter(base => base.keyword === selectedBaseNode)
            .map(({ title, originalTitle, keyword, sample, weighted }) => ({
              keyword,
              title,
              originalTitle,
              sample,
              weighted,
            }));
        } else if (selectedBaseGroup === 'standard-base') {
          selectedBase = StandardBasesDataGridData.filter(
            base => base.keyword === selectedBaseNode
          ).map(({ title, originalTitle, keyword, sample, weighted }) => ({
            keyword,
            title,
            originalTitle,
            sample,
            weighted,
          }));
        }
        const columns = crosstabColumns.map(
          ({ title, originalTitle, keyword, sample, weighted }) => ({
            keyword,
            title,
            originalTitle,
            sample,
            weighted,
            isPassive: false,
            isShow: true,
          })
        );
        const rows = crosstabRows.map(
          ({ title, originalTitle, keyword, sample, weighted }) => ({
            keyword,
            title,
            originalTitle,
            sample,
            weighted,
            isPassive: false,
            isShow: true,
          })
        );
        if (selectedBase.length === 0) {
          selectedBase = [
            {
              keyword: 'StudyUniverseKey',
              title: 'STUDY UNIVERSE',
              originalTitle: 'STUDY UNIVERSE',
            },
          ];
        }
        this.props.cacActions.creatCACProject({
          base: selectedBase,
          columns,
          rows,
          study: crosstabStudy,
          weightTypes: this.props.crosstabWeightTypes,
          viewMode: CAC_LEFT_PANEL_VIEW_LABEL,
          title: this.state.ctbTitle !== '' ? this.state.ctbTitle : undefined,
          corrMapView: true,
          clusterMapView: false,
        });
        this.context.router.push(
          `${APP_ROOT_URL}/essentials/correspondencecluster`
        );
      } else {
        this.setState({ showCurrCLusterModal: true });
      }
    } else {
      this.setState({ showCacMaxLimitModal: true });
    }
  };

  callSaveTrackerFn = ({ action, attributes = undefined, subModule = undefined }) => {
    const productNo =
      this.props.crosstabStudy !== undefined
        ? this.props.crosstabStudy.pn
        : undefined;
    saveTrackingData({
      uid: this.props.loginResponse.data.uid,
      accid: this.props.activeAccountId,
      productNo,
      moduleName:
        this.props.dataScreen !== undefined
          ? this.props.dataScreen
          : CROSSTAB_CONSTANT,
      subModule,
      attributes,
      action,
    });
  };

  render() {
    if (
      this.state.cbCrosstabRunType === 'Trend' &&
      !this.state.openCrossTabMultipleProducts &&
      this.validateTrend &&
      this.validateTrend.flag &&
      this.state.defaultScreenSelected === 'Smart Search' &&
      this.state.screenSelected !== 'autocode' &&
      !this.state.shouldTrendPopupShow &&
      !this.state.isDictionarySearchOpened
    ) {
      return (
        <ValidateTrendModal
          show={this.validateTrend.flag}
          modalData={this.validateTrend.modalData}
          handleCancel={this.handleTrendCancel}
          handleComplete={this.handleTrendComplete}
          trendStudies={this.state.trendStudies}
        />
      );
    }
    const { hasCrosstabFeature, hasDataHaulFeature } = this.state;
    if (!this.props.dataScreen && !hasCrosstabFeature) {
      return (
        <div className="no-study-message">
          <WarningIcon />
          <p>
            You do not currently have permissions to the Crosstab application.
            Please contact your Account Manager to learn more about your access.
          </p>
        </div>
      );
    }
    if (this.props.dataScreen === DATAHAUL_CONSTANT && !hasDataHaulFeature) {
      return (
        <div className="no-study-message">
          <WarningIcon />
          <p>
            You do not currently have permissions to the Datahaul application.
            Please contact your Account Manager to learn more about your access.
          </p>
        </div>
      );
    }

    if (!this.props.dataScreen && hasCrosstabFeature) {
      if (!this.state.hasCrosstabStudies) {
        return (
          <div className="no-study-message">
            <WarningIcon />
            <p>
              You do not currently have studies to the Crosstab application.
              Please contact your Account Manager to learn more about your
              studies.
            </p>
          </div>
        );
      }
    }

    if (this.props.dataScreen === DATAHAUL_CONSTANT && hasDataHaulFeature) {
      if (!this.state.hasDatahaulStudies) {
        return (
          <div className="no-study-message">
            <WarningIcon />
            <p>
              You do not currently have studies to the DataHaul application.
              Please contact your Account Manager to learn more about your
              studies.
            </p>
          </div>
        );
      }
    }
    return (
      <div>
        {this.state.screenSelected === '' && (
          <input
            type="checkbox"
            className="sidebar-left"
            id="sidebar-left-01"
            onChange={this.handlesideBarToggle}
            checked={this.state.sideBarChecked}
          />
        )}
        {this.state.screenSelected === '' && (
          <label className="sidebar-left" htmlFor="sidebar-left-01" />
        )}
        {this.state.screenSelected === '' && (
          <ToolPalette
            columns={this.props.crosstabColumns}
            rows={this.props.crosstabRows}
            bases={this.props.crosstabBases}
            DataHaulBases={this.props.DataHaulBases}
            DataHaulColumns={this.props.DataHaulColumns}
            handleMetricsChange={this.handleMetricsChange}
            getCrosstabTitle={this.getCrosstabTitle}
            handleCrosstabEdit={this.handleCrosstabEdit}
            dataScreen={this.props.dataScreen}
            resetSmarchSearch={this.resetSmarchSearch}
            isSmartSearchSelected={this.getSelectedEditor()}
            runCrosstab={this.runCrosstabOrTrend}
            handleSaveCrosstab={this.handleSaveCrosstab}
            cbCrossTabViewTypeChanged={this.handlecbCrossTabViewTypeChanged}
            resetTitle={this.resetTitle}
            shareCrosstab={this.shareCrosstabIcon}
            resetHighlightFilterState={this.resetHighlightFilterState}
            toolPaletteSavedName={this.state.toolPaletteSavedName}
            toggleCheckVal={this.props.toggleCheckVal}
            ref={this.leftToolPalette}
            cbCrosstabRunType={this.state.cbCrosstabRunType}
            enableCorrespondence={this.enableCorrespondence}
          />
        )}
        <div
          className={`${
            this.state.screenSelected === 'autocode'
              ? 'width-955 width-100'
              : this.state.isDictionarySearchOpened
              ? 'width-955 width-80'
              : 'width-80'
          } portfolio-crosstab float-left`}
          style={{
            height: 'calc(100vh - 57px)',
          }}
        >
          <div className="crosstab-accordion">
            <CrosstabEditor
              crosstabStudy={this.props.crosstabStudy}
              datahaulStudy={this.props.datahaulStudy}
              studies={this.props.studies}
              getSampleWeighted={this.props.crosstabActions.getSampleWeighted}
              fetchKPI={this.props.crosstabActions.fetchKPI}
              gridData={this.getGridData()}
              cellElementList={this.state.cellElementList}
              runCrosstab={this.runCrosstabOrTrend}
              runDataHaul={this.runDataHaul}
              dataScreen={this.props.dataScreen}
              ref={node => {
                this.crosstabEditor = node;
                return this.crosstabEditor;
              }}
              stopSpinner={() => this.setState({ isRunPressed: false })}
              cdDictionarySearchOpened={this.handleDictionarySearchOpened}
              trackerFn={this.callSaveTrackerFn}
              isSmartSearchSelected={this.state.defaultScreenSelected}
              handlesideBarToggle={this.handlesideBarToggle}
              handleStudyChange={this.handleStudyChange}
              hideWeightType={this.state.hideWeightType}
              selectedBase={this.props.selectedBase}
              runAfterWeightChange={this.runAfterWeightChange}
              changeViewType={this.changeViewType}
              handleSaveCrosstab={this.handleSaveCrosstab}
              handleScreenSelection={this.handleScreenSelection}
              activeAccountId={this.props.activeAccountId}
              uid={this.props.loginResponse.data.uid}
            />
          </div>
          <Modal
            title="Maximum limit reached!"
            ref={node => {
              this.warnCTLimit = node;
              return this.warnCTLimit;
            }}
            dialogStyles={warnCTLimitStyle}
          >
            <p>
              You have reached the maximum supported total number of rows and
              columns (100,000). Please remove some rows or columns and run your
              report again. Alternatively, please export the report directly to
              Excel.
            </p>
            <p>
              To ensure faster results and reduce the burden on your browser
              memory, Simmons Insights limits the number of rows X columns in
              the Crosstab output to 100,000. For example, 100 rows X 1000
              columns, 10 rows X 10000 columns etc. If you need to run a
              Crosstab that exceeds this limit, you can always select your rows
              and columns and export the report directly to Excel.
            </p>
            <div className="text-center">
              <GenericButton
                name="Ok"
                onBtnClick={() => this.warnCTLimit.hide()}
              />
            </div>
          </Modal>
          <Modal
            title={
              this.state.openCrossTabMultipleProducts
                ? 'Validate Open Crosstab'
                : 'Validate Study Results'
            }
            ref={node => {
              this.validateStudyModal = node;
              return this.validateStudyModal;
            }}
            dialogStyles={validateModalStyle}
          >
            {this.props.dataScreen !== DATAHAUL_CONSTANT && (
              <div>
                {this.state.openCrossTabMultipleProducts ? (
                  <ValidateMultipleStudyModal
                    handleParentHide={() => this.validateStudyModal.hide()}
                    moduleStudy={this.props.crosstabStudy}
                    invalidData={this.state.invalidData}
                    trendStudies={this.props.trendStudies}
                    crosstabStudy={this.props.crosstabStudy}
                    gridsValidationResponse={
                      this.state.gridsValidationResponseOriginal
                    }
                    openCrossTabMultipleProducts={
                      this.state.openCrossTabMultipleProducts
                    }
                  />
                ) : (
                  <ValidateStudyModal
                    handleParentHide={() => this.validateStudyModal.hide()}
                    moduleStudy={this.props.crosstabStudy}
                    invalidData={this.state.invalidData}
                  />
                )}
              </div>
            )}
            {this.props.dataScreen === DATAHAUL_CONSTANT && (
              <div>
                <ValidateStudyModal
                  handleParentHide={() => this.validateStudyModal.hide()}
                  moduleStudy={this.props.crosstabStudy}
                  invalidData={this.state.invalidData}
                  dataScreen={DATAHAUL_CONSTANT}
                />
              </div>
            )}
          </Modal>
          {this.renderUserStateModal()}
          <Modal
            title=""
            ref={node => {
              this.crosstabSaveModal = node;
              return this.crosstabSaveModal;
            }}
            dialogStyles={CrosstabSaveModalStyle}
            resetInfo={this.resetInfo}
          >
            <p>
              <b>Enter the crosstab Name</b>
            </p>
            {this.state.isCrosstabExist && (
              <p style={{ color: 'rgb(255, 0, 0)' }}>
                A Crosstab with the same name already exists in your account.
              </p>
            )}
            <div className="row">
              <input
                type="text"
                placeholder="Enter Crosstab Name"
                className="display-inline width-200"
                style={{ marginLeft: 10, width: 400 }}
                onChange={e => {
                  if (e.target.value.length === 0 || e.target.value.trim()) {
                    this.setState({
                      ctbTitle: e.target.value,
                      toolPaletteSavedName: e.target.value,
                    });
                  }
                }}
                value={this.state.ctbTitle}
              />
            </div>
            <div className="row crossTabNameModal">
              <GenericButton
                name="Save"
                btnStyle="button margin-left-10 margin-right-10 margin-top-5"
                btnDisabled={!this.state.ctbTitle}
                onBtnClick={() => {
                  if (this.state.ctbTitle) {
                    this.saveCrosstab(false);
                  }
                }}
              />
              <GenericButton
                name="Cancel"
                btnStyle="button margin-left-10 margin-right-10 margin-top-5"
                onBtnClick={() => {
                  this.setState(
                    () => ({
                      saveModalOpen: false,
                      ctbTitle: '',
                      isCrosstabExist: false,
                    }),
                    () => {
                      const { loadedCrosstabInfo } = this.props;
                      if (loadedCrosstabInfo.isDuplicateCrossTabTitle) {
                        // remove loadedCrosstabInfo from reducer;
                        this.props.crosstabActions.resetLoadedCrossTabInfo();
                      }
                    }
                  );
                  this.crosstabSaveModal.hide();
                }}
              />
            </div>
          </Modal>
          <Modal
            title=""
            ref={node => {
              this.crosstabSaveReplaceModal = node;
              return this.crosstabSaveReplaceModal;
            }}
            dialogStyles={CrosstabSaveReplaceModalStyle}
          >
            <p>
              {this.props.crosstabTableList &&
              this.props.crosstabTableList.length > 0 &&
              this.getCrosstabTitle() !== 'untitled'
                ? this.getCrosstabTitle()
                : 'File'}{' '}
              already exists. A Crosstab with the same name already exists in
              your account. Would you like to save as a new name?
            </p>
            <div className="row crossTabNameModal padding-left-10">
              <GenericButton
                name="Save"
                btnStyle="button btn-cncl margin-right-10"
                btnDisabled={!this.state.ctbTitle}
                onBtnClick={() => {
                  this.saveCrosstab(true);
                  this.crosstabSaveReplaceModal.hide();
                }}
              />
              <input
                type="text"
                placeholder="Enter Crosstab Name"
                className="display-inline width-200"
                onChange={e => {
                  if (e.target.value.length === 0 || e.target.value.trim()) {
                    this.setState({
                      ctbTitle: e.target.value,
                      editFromToolPalette: true,
                    });
                  }
                }}
                value={this.state.ctbTitle}
              />
              <GenericButton
                name="Save As"
                btnStyle="button margin-left-10 margin-right-10"
                btnDisabled={!this.state.ctbTitle}
                onBtnClick={() => {
                  if (
                    this.props.activeCrosstabTable &&
                    this.getCrosstabTitle() !== this.state.ctbTitle
                  ) {
                    this.saveCrosstab(false);
                    this.crosstabSaveReplaceModal.hide();
                  }
                }}
              />
            </div>
          </Modal>
          <PortalModal
            isShowing={this.state.showCurrCLusterModal}
            hide={() => this.setState({ showCurrCLusterModal: false })}
            title={CAC_MODULE_TITLE}
            dialogStyles={minRequireModalStyle}
            onCloseClicked={() =>
              this.setState({ showCurrCLusterModal: false })
            }
          >
            <div>{INSUFFICIENT_DATA_MODAL_TEXT.split('|')[0]}</div>
            <div style={{ paddingBottom: '15px' }}>
              {INSUFFICIENT_DATA_MODAL_TEXT.split('|')[1]}
            </div>
            <div className="text-center">
              <GenericButton
                name="Ok"
                onBtnClick={() =>
                  this.setState({ showCurrCLusterModal: false })
                }
              />
            </div>
          </PortalModal>
          <PortalModal
            isShowing={this.state.showCacMaxLimitModal}
            hide={() => this.setState({ showCacMaxLimitModal: false })}
            title={CAC_MODULE_TITLE}
            dialogStyles={currClusterModalStyle}
            onCloseClicked={() =>
              this.setState({ showCacMaxLimitModal: false })
            }
          >
            <p>{CAC_MAX_LIMIT_REACHED_LABEL}</p>
            <div className="text-center">
              <GenericButton
                name="Ok"
                onBtnClick={() =>
                  this.setState({ showCacMaxLimitModal: false })
                }
              />
            </div>
          </PortalModal>
          <PortalModal
            isShowing={this.state.showStudyUpdatePopup}
            title=""
            dialogStyles={updatedStudyPopupStyle}
            onCloseClicked={() =>
              this.setState({ showStudyUpdatePopup: false })
            }
          >
            <H6>UPDATE NOTIFICATION</H6>
            <H6>
              Study Name:{' '}
              {this.props.crosstabStudy && this.props.crosstabStudy.sd}
            </H6>
            <p>
              This study was updated with changes to data in the following
              categories/areas:
            </p>
            <p>Data Correction for USA Today and Wall Street Journal</p>
            <p>
              You can always view a detailed summary of these updates in the
              Resources section.
            </p>
            <BtnContainer>
              <GenericButton
                name="SEE THE UPDATES NOW"
                btnStyle="button btn-ok study-update-popup-btn"
                onBtnClick={() => {}}
              />
              <GenericButton
                name="GO TO INSIGHTS"
                btnStyle="button btn-ok study-update-popup-btn-goto"
                onBtnClick={() => {}}
              />
            </BtnContainer>
          </PortalModal>
        </div>
      </div>
    );
  }
}

Crosstab.propTypes = {
  crosstabTableList: PropTypes.arrayOf(PropTypes.object),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
      universityUser: PropTypes.bool,
    }),
  }),
  activeAccountId: PropTypes.number,
  kpiInfo: PropTypes.shape({}),
  trendStudies: PropTypes.arrayOf(PropTypes.object),
  crosstabColumns: PropTypes.arrayOf(PropTypes.object),
  crosstabRows: PropTypes.arrayOf(PropTypes.object),
  crosstabBases: PropTypes.arrayOf(PropTypes.object),
  crosstabScratch: PropTypes.arrayOf(PropTypes.object),
  recycleElements: PropTypes.arrayOf(PropTypes.object),
  gridsValidationResponse: PropTypes.shape({}),
  gridsValidationResponse1: PropTypes.shape({}),
  sampleWeightedKPIs: PropTypes.shape({}),
  CrosstabBreadCrumbsList: PropTypes.shape({
    ColumnsGrid: PropTypes.shape({}),
    RowsGrid: PropTypes.shape({}),
  }),
  DictionaryDetails: PropTypes.shape({
    ColumnsGrid: PropTypes.shape({}),
    RowsGrid: PropTypes.shape({}),
  }),
  crosstabWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
  }),
  datahaulWeightTypes: PropTypes.shape({
    wt: PropTypes.number,
    dv: PropTypes.number,
    wn: PropTypes.string,
  }),
  crosstabStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
    cw: PropTypes.arrayOf(PropTypes.shape({})),
    sd: PropTypes.string,
  }),
  datahaulStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
    cw: PropTypes.arrayOf(PropTypes.shape({})),
    sd: PropTypes.string,
    ss: PropTypes.string,
  }),
  visahaulStudy: PropTypes.shape({
    pn: PropTypes.number,
    dv: PropTypes.number,
    wt: PropTypes.number,
    cw: PropTypes.arrayOf(PropTypes.shape({})),
    sd: PropTypes.string,
  }),
  savedCrosstabData: PropTypes.shape({
    attributes: PropTypes.shape({
      highlightAndFilter: PropTypes.shape({}),
      conditionalFormatting: PropTypes.string,
      chartType: PropTypes.string,
    }),
    products: PropTypes.instanceOf(Array),
    weightType: PropTypes.number,
    divisor: PropTypes.number,
    cw: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  studies: PropTypes.arrayOf(PropTypes.object),
  latestStudies: PropTypes.shape({
    _dh: PropTypes.shape({
      productNo: PropTypes.number,
    }),
    _ct: PropTypes.shape({
      productNo: PropTypes.number,
    }),
  }),
  crosstabActions: PropTypes.shape({
    getBreadCrumbs: PropTypes.func,
    removeCrosstabData: PropTypes.func,
    clearSampleWeighted: PropTypes.func,
    validateCRB: PropTypes.func,
    validateNewSpcCRB: PropTypes.func,
    getSampleWeighted: PropTypes.func,
    getSampleWeightedData: PropTypes.func,
    fetchKPI: PropTypes.func,
    runCrosstab: PropTypes.func,
    addDDNHCSData: PropTypes.func,
    resetLoadedCrossTabInfo: PropTypes.func,
    fetchStandardBaseList: PropTypes.func,
    validateCRBForMultipleProducts: PropTypes.func,
    validateNewSpcCRBForMultipleProducts: PropTypes.func,
    setSelectedBase: PropTypes.func,
    exportBaseSelectionList: PropTypes.func,
    updateRenamedGridIndex: PropTypes.func,
    fetchTrendsKPI: PropTypes.func,
    saveCrosstab: PropTypes.func,
    clearSampleWeightedKPIs: PropTypes.func,
    getDictionaryDataDetails: PropTypes.func,
    saveNewSPCCrosstab: PropTypes.func,
  }),
  studyActions: PropTypes.shape({
    updateModuleStudy: PropTypes.func,
    setTrendStudies: PropTypes.func,
    clearTrendStudies: PropTypes.func,
    updateWeightType: PropTypes.func,
    getFootNotes: PropTypes.func,
  }),
  dataScreen: PropTypes.string,
  datahaulActions: PropTypes.shape({
    updateDatahaulReportsKafka: PropTypes.func,
  }),
  dictionaryActions: PropTypes.shape({
    clearTreeNodes: PropTypes.func,
    setDataPointAlreadyAdded: PropTypes.func,
    clearTreeLoadNodeList: PropTypes.func,
  }),
  loadedCrosstabInfo: PropTypes.shape({
    title: PropTypes.string,
    chartType: PropTypes.string,
    isDuplicateCrossTabTitle: PropTypes.bool,
  }),
  selectedBase: PropTypes.string,
  StandardBasesDataGridData: PropTypes.arrayOf(PropTypes.object),
  currentState: PropTypes.shape({}),
  getLastUnsavedDetails: PropTypes.func,
  openLastCrosstab: PropTypes.func,
  discardLastCrosstab: PropTypes.func,
  lastCrosstabData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  saveLastCrosstab: PropTypes.func,
  preferenceActions: PropTypes.shape({
    setLastLocation: PropTypes.func,
    setPreferenceFlag: PropTypes.func,
    saveUserPreferences: PropTypes.func,
  }),
  preferenceFlags: PropTypes.shape({
    crosstab: PropTypes.bool,
  }),
  userPreferences: PropTypes.shape({
    _ct: PropTypes.shape({
      _aus: PropTypes.bool,
      _ds: PropTypes.number,
      productNo: PropTypes.number,
    }),
    _dh: PropTypes.shape({
      _aus: PropTypes.bool,
      _ds: PropTypes.number,
      productNo: PropTypes.number,
    }),
  }),
  setModuleDataOnSave: PropTypes.func,
  modulePermissions: PropTypes.instanceOf(Array),
  hasCrosstabStudies: PropTypes.bool,
  hasDatahaulStudies: PropTypes.bool,
  crosstabRequestData: PropTypes.shape({}),
  cacActions: PropTypes.shape({
    creatCACProject: PropTypes.func,
  }),
  selectedBaseGroup: PropTypes.string,
  selectedBaseNode: PropTypes.string,
  activeCrosstabTable: PropTypes.shape({
    rowExpressionList: PropTypes.instanceOf(Array),
    colExpressionList: PropTypes.instanceOf(Array),
    idKey: PropTypes.string,
  }),
  cacProjectCount: PropTypes.number,
  quickReportsActions: PropTypes.shape({
    clearSampleWeightedKPIs: PropTypes.func,
  }),
  storeUnsavedData: PropTypes.func,
  DataHaulBases: PropTypes.instanceOf(Array),
  DataHaulColumns: PropTypes.instanceOf(Array),
  weightTypeStudies: PropTypes.instanceOf(Array),
  isUserStatePopupShown: PropTypes.shape({
    crosstab: PropTypes.bool,
  }),
  noLastSavedCrosstabFlag: PropTypes.bool,
  isTitleUpdated: PropTypes.bool,
  toggleCheckVal: PropTypes.bool,
  partsToShow: PropTypes.shape({}),
  savedNewSPCCrosstabData: PropTypes.shape({
    products: PropTypes.instanceOf(Array),
    weightType: PropTypes.number,
    divisor: PropTypes.number,
    cw: PropTypes.number,
    highlightAndFilter: PropTypes.shape({}),
    conditionalFormatting: PropTypes.string,
    chartType: PropTypes.string,
  }),
  newSpcGridValidationResponse: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    lastCrosstabData: state.login.lastCrosstabData,
    noLastSavedCrosstabFlag: state.login.noLastSavedCrosstabFlag,
    isUserStatePopupShown: state.login.isUserStatePopupShown,
    activeAccountId: state.account.activeAccountId,
    crosstabStudy: state.study.crosstabStudy,
    datahaulStudy: state.study.datahaulStudy,
    trendStudies: state.study.trendStudies,
    crosstabWeightTypes: state.study.crosstabWeightTypes,
    datahaulWeightTypes: state.study.datahaulWeightTypes,
    studies: state.study.studies,
    trendComplete: state.crosstab.trendComplete,
    crosstabColumns: state.crosstab.ColumnsDataGridData,
    crosstabRows: state.crosstab.RowsDataGridData,
    gridsValidationResponse: state.crosstab.gridsValidationResponse,
    crosstabBases: state.crosstab.BasesDataGridData,
    savedCrosstabData: state.crosstab.savedCrosstabData,
    savedNewSPCCrosstabData: state.crosstab.savedNewSPCCrosstabData,
    newSpcGridValidationResponse: state.crosstab.newSpcGridValidationResponse,
    crosstabTableList: state.crosstab.crosstabTableList,
    kpiInfo: state.crosstab.kpiInfo,
    crosstabScratch: state.crosstab.ScratchDataGridData,
    recycleElements: state.crosstab.RecycleGridData,
    ddNHCSReportsList: state.crosstab.ddNHCSReportsList,
    DataHaulBases: state.crosstab.DataHaulBasesDataGridData,
    DataHaulColumns: state.crosstab.DataHaulColumnsDataGridData,
    sampleWeightedKPIs: state.crosstab.sampleWeightedKPIs,
    activeCrosstabTable: state.crosstab.activeCrosstabTable,
    loadedCrosstabInfo: state.crosstab.loadedCrosstabInfo,
    isTitleUpdated: state.crosstab.isTitleUpdated,
    currentState: state,
    selectedBase: state.selectedBase.selectedBase,
    selectedBaseNode: state.selectedBase.selectedBaseNode,
    selectedBaseGroup: state.selectedBase.selectedBaseGroup,
    StandardBasesDataGridData: state.crosstab.StandardBasesDataGridData,
    userPreferences: state.preferences.userPreferences,
    preferenceFlags: state.preferences.preferenceFlags,
    latestStudies: state.study.latestStudies,
    modulePermissions: state.userDetail.permissions,
    hasCrosstabStudies: state.study.hasCrosstabStudies,
    hasDatahaulStudies: state.study.hasDatahaulStudies,
    crosstabRequestData: state.crosstab.crosstabRequestData,
    toggleCheckVal: state.crosstab.toggleCheckValue,
    CrosstabBreadCrumbsList: state.crosstab.CrosstabBreadCrumbsList,
    DictionaryDetails: state.crosstab.DictionaryDetails,
    cacProjectCount: state.correspondenceCluster.projects.length,
    partsToShow: state.crosstab.partsToShow,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
    studyActions: bindActionCreators(studyActions, dispatch),
    datahaulActions: bindActionCreators(datahaulActions, dispatch),
    dictionaryActions: bindActionCreators(dictionaryActions, dispatch),
    getLastUnsavedDetails: bindActionCreators(getLastUnsavedDetails, dispatch),
    openLastCrosstab: bindActionCreators(openLastCrosstab, dispatch),
    discardLastCrosstab: bindActionCreators(discardLastCrosstab, dispatch),
    saveLastCrosstab: bindActionCreators(saveLastCrosstab, dispatch),
    storeUnsavedData: bindActionCreators(storeUnsavedData, dispatch),
    preferenceActions: bindActionCreators(preferenceActions, dispatch),
    quickReportsActions: bindActionCreators(quickReportsActions, dispatch),
    setModuleDataOnSave: bindActionCreators(setModuleDataOnSave, dispatch),
    cacActions: bindActionCreators(cacActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Crosstab);
